var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2TaDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88108",
    "data-name": "Group 88108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 441.717,
    height: 393.162,
    viewBox: "0 0 441.717 393.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25554",
    "data-name": "Rectangle 25554",
    width: 441.716,
    height: 393.162,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25539",
    "data-name": "Rectangle 25539",
    width: 89.939,
    height: 124.856,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25549",
    "data-name": "Rectangle 25549",
    width: 38.202,
    height: 36.511,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25550",
    "data-name": "Rectangle 25550",
    width: 42.987,
    height: 44.464,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25551",
    "data-name": "Rectangle 25551",
    width: 49.48,
    height: 50.38,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87914",
    "data-name": "Group 87914",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87913",
    "data-name": "Group 87913",
    transform: "translate(5.33 33.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87915",
    "data-name": "Group 87915",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276419",
    "data-name": "Path 276419",
    d: "M47.9,70.88a.477.477,0,0,1-.476-.476v-56.2a.476.476,0,0,1,.951,0V70.4a.477.477,0,0,1-.476.476",
    transform: "translate(79.184 -8.915)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276420",
    "data-name": "Path 276420",
    d: "M47.9,312.561a.477.477,0,0,1-.476-.476V36.418a.476.476,0,0,1,.951,0V312.085a.477.477,0,0,1-.476.476",
    transform: "translate(79.184 30.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25519",
    "data-name": "Rectangle 25519",
    width: 8.613,
    height: 38.188,
    transform: "translate(142.438 11.93)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276421",
    "data-name": "Path 276421",
    d: "M62.037,55.255H53.421a.477.477,0,0,1-.476-.476V16.594a.477.477,0,0,1,.476-.476h8.616a.479.479,0,0,1,.476.476V54.779a.479.479,0,0,1-.476.476M53.9,54.3h7.664V17.069H53.9Z",
    transform: "translate(89.017 -4.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25520",
    "data-name": "Rectangle 25520",
    width: 8.613,
    height: 3.733,
    transform: "translate(142.438 17.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276422",
    "data-name": "Path 276422",
    d: "M62.037,22.867H53.421a.477.477,0,0,1-.476-.476V18.658a.477.477,0,0,1,.476-.476h8.616a.479.479,0,0,1,.476.476v3.733a.479.479,0,0,1-.476.476m-8.14-.951h7.664V19.136H53.9Z",
    transform: "translate(89.017 -0.985)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25521",
    "data-name": "Rectangle 25521",
    width: 8.613,
    height: 3.733,
    transform: "translate(142.438 41.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276423",
    "data-name": "Path 276423",
    d: "M62.037,31.38H53.421a.477.477,0,0,1-.476-.476V27.174a.477.477,0,0,1,.476-.476h8.616a.479.479,0,0,1,.476.476V30.9a.479.479,0,0,1-.476.476m-8.14-.951h7.664V27.649H53.9Z",
    transform: "translate(89.017 14.19)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25522",
    "data-name": "Rectangle 25522",
    width: 12.06,
    height: 38.188,
    transform: "translate(149.04 11.93)",
    fill: "#fda12c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276424",
    "data-name": "Path 276424",
    d: "M67.851,55.255H55.794a.479.479,0,0,1-.476-.476V16.594a.479.479,0,0,1,.476-.476H67.851a.477.477,0,0,1,.476.476V54.779a.477.477,0,0,1-.476.476M56.272,54.3h11.1V17.069h-11.1Z",
    transform: "translate(93.246 -4.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25523",
    "data-name": "Rectangle 25523",
    width: 8.613,
    height: 38.188,
    transform: "translate(151.624 11.93)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276425",
    "data-name": "Path 276425",
    d: "M65.338,55.255H56.722a.477.477,0,0,1-.476-.476V16.594a.477.477,0,0,1,.476-.476h8.616a.477.477,0,0,1,.476.476V54.779a.477.477,0,0,1-.476.476M57.2,54.3h7.664V17.069H57.2Z",
    transform: "translate(94.899 -4.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25524",
    "data-name": "Rectangle 25524",
    width: 8.613,
    height: 3.733,
    transform: "translate(151.624 17.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276426",
    "data-name": "Path 276426",
    d: "M65.338,22.867H56.722a.477.477,0,0,1-.476-.476V18.658a.477.477,0,0,1,.476-.476h8.616a.477.477,0,0,1,.476.476v3.733a.477.477,0,0,1-.476.476m-8.14-.951h7.664V19.136H57.2Z",
    transform: "translate(94.899 -0.985)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25525",
    "data-name": "Rectangle 25525",
    width: 8.613,
    height: 3.733,
    transform: "translate(151.624 41.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276427",
    "data-name": "Path 276427",
    d: "M65.338,31.38H56.722a.477.477,0,0,1-.476-.476V27.174a.477.477,0,0,1,.476-.476h8.616a.477.477,0,0,1,.476.476V30.9a.477.477,0,0,1-.476.476m-8.14-.951h7.664V27.649H57.2Z",
    transform: "translate(94.899 14.19)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25526",
    "data-name": "Rectangle 25526",
    width: 12.06,
    height: 38.188,
    transform: "translate(158.226 11.93)",
    fill: "#fda12c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276428",
    "data-name": "Path 276428",
    d: "M71.158,55.255H59.1a.477.477,0,0,1-.476-.476V16.594a.477.477,0,0,1,.476-.476H71.158a.477.477,0,0,1,.476.476V54.779a.477.477,0,0,1-.476.476M59.571,54.3H70.683V17.069H59.571Z",
    transform: "translate(99.13 -4.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25527",
    "data-name": "Rectangle 25527",
    width: 8.613,
    height: 38.188,
    transform: "translate(160.813 11.93)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276429",
    "data-name": "Path 276429",
    d: "M68.642,55.255H60.026a.477.477,0,0,1-.476-.476V16.594a.477.477,0,0,1,.476-.476h8.616a.477.477,0,0,1,.476.476V54.779a.477.477,0,0,1-.476.476M60.5,54.3h7.664V17.069H60.5Z",
    transform: "translate(100.787 -4.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25528",
    "data-name": "Rectangle 25528",
    width: 8.613,
    height: 3.733,
    transform: "translate(160.813 17.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276430",
    "data-name": "Path 276430",
    d: "M68.642,22.867H60.026a.477.477,0,0,1-.476-.476V18.658a.477.477,0,0,1,.476-.476h8.616a.477.477,0,0,1,.476.476v3.733a.477.477,0,0,1-.476.476m-8.14-.951h7.664V19.136H60.5Z",
    transform: "translate(100.787 -0.985)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25529",
    "data-name": "Rectangle 25529",
    width: 8.613,
    height: 3.733,
    transform: "translate(160.813 41.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276431",
    "data-name": "Path 276431",
    d: "M68.642,31.38H60.026a.477.477,0,0,1-.476-.476V27.174a.477.477,0,0,1,.476-.476h8.616a.477.477,0,0,1,.476.476V30.9a.477.477,0,0,1-.476.476m-8.14-.951h7.664V27.649H60.5Z",
    transform: "translate(100.787 14.19)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25530",
    "data-name": "Rectangle 25530",
    width: 12.06,
    height: 38.188,
    transform: "translate(167.415 11.93)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276432",
    "data-name": "Path 276432",
    d: "M74.454,55.255H62.4a.477.477,0,0,1-.476-.476V16.594a.477.477,0,0,1,.476-.476H74.454a.477.477,0,0,1,.476.476V54.779a.477.477,0,0,1-.476.476M62.875,54.3h11.1V17.069h-11.1Z",
    transform: "translate(105.018 -4.663)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276433",
    "data-name": "Path 276433",
    d: "M69.254,33.27H89.49L94.876,28.4H69.254Z",
    transform: "translate(118.079 17.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276434",
    "data-name": "Path 276434",
    d: "M89.793,34.047H69.56a.477.477,0,0,1-.476-.476v-4.86a.477.477,0,0,1,.476-.476H95.176a.478.478,0,0,1,.323.829l-5.383,4.86a.5.5,0,0,1-.323.122M70.035,33.1H89.61l4.332-3.909H70.035Z",
    transform: "translate(117.777 16.929)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276435",
    "data-name": "Path 276435",
    d: "M92.852,30.987l-.643-1.11L69.1,29.827l.67,1.16Z",
    transform: "translate(117.808 19.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276436",
    "data-name": "Path 276436",
    d: "M93.157,31.768H70.083a.477.477,0,0,1-.409-.236l-.682-1.16a.47.47,0,0,1,0-.476.479.479,0,0,1,.415-.239L92.52,29.7a.482.482,0,0,1,.415.236l.637,1.116a.47.47,0,0,1,0,.476.493.493,0,0,1-.415.236m-22.8-.951H92.336l-.092-.161-22.008-.047Z",
    transform: "translate(117.498 19.461)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25531",
    "data-name": "Rectangle 25531",
    width: 8.613,
    height: 38.188,
    transform: "translate(168.159 17.027) rotate(-30.043)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276437",
    "data-name": "Path 276437",
    d: "M81.783,54.722a.638.638,0,0,1-.125-.014.482.482,0,0,1-.289-.223L62.254,21.427a.48.48,0,0,1,.178-.654l7.456-4.315a.537.537,0,0,1,.362-.045.5.5,0,0,1,.292.223L89.653,49.695a.478.478,0,0,1-.178.651L82.02,54.661a.49.49,0,0,1-.236.061M63.322,21.366,81.958,53.6l6.627-3.839L69.949,17.527Z",
    transform: "translate(105.492 -4.161)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25532",
    "data-name": "Rectangle 25532",
    width: 8.613,
    height: 3.732,
    transform: "translate(171.035 21.999) rotate(-30.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276438",
    "data-name": "Path 276438",
    d: "M65.567,26.678a.616.616,0,0,1-.122-.017.5.5,0,0,1-.292-.223l-1.867-3.233a.478.478,0,0,1,.178-.654l7.456-4.307a.5.5,0,0,1,.654.175l1.872,3.227a.478.478,0,0,1-.175.651l-7.464,4.318a.565.565,0,0,1-.239.061m-1.213-3.533,1.391,2.4,6.632-3.839-1.4-2.4Z",
    transform: "translate(107.331 -0.971)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25533",
    "data-name": "Rectangle 25533",
    width: 8.613,
    height: 3.732,
    transform: "translate(182.893 42.505) rotate(-30.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276439",
    "data-name": "Path 276439",
    d: "M69.835,34.046a.481.481,0,0,1-.415-.239l-1.875-3.224a.485.485,0,0,1,.178-.654l7.456-4.315a.5.5,0,0,1,.654.178l1.872,3.233a.478.478,0,0,1-.175.651l-7.459,4.309a.507.507,0,0,1-.236.061m-1.221-3.525,1.4,2.4,6.627-3.831-1.4-2.4Z",
    transform: "translate(114.928 12.161)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276440",
    "data-name": "Path 276440",
    d: "M102.373,49.732l-18.286-.05L64.969,16.623l18.286.05Z",
    transform: "translate(110.443 -3.763)",
    fill: "#fed5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276441",
    "data-name": "Path 276441",
    d: "M102.679,50.516h0L84.4,50.461a.482.482,0,0,1-.415-.236L64.86,17.166a.47.47,0,0,1,0-.476.479.479,0,0,1,.415-.239l18.292.053a.492.492,0,0,1,.415.239L103.093,49.8a.483.483,0,0,1,0,.476.492.492,0,0,1-.415.239M84.671,49.509l17.179.053-18.561-32.1L66.1,17.4Z",
    transform: "translate(110.135 -4.07)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276442",
    "data-name": "Path 276442",
    d: "M85.753,42.861s-3.33-1.188-4.279-6.421-2.615-12.6-.715-14.263,5.469-2.618,5.945.712-.239,9.748.476,11.175,3.091.476,3.091-2.379c0-4.7-1.931-9.506-1.224-14.3.974-6.577,7.609-7.3,8.324-.036.4,4.031.509,8.148.509,12.2,0,1.664,2.852,2.615,2.615-1.427-.17-2.888,1.9-6.182,4.754-5.23s.476,13.551-.476,15.693S97.88,41.2,97.88,41.2v5.467l-7.133.239-.239-5.469a10.75,10.75,0,0,1-4.754,1.427",
    transform: "translate(137.031 -11.694)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276443",
    "data-name": "Path 276443",
    d: "M91.052,47.689a.481.481,0,0,1-.479-.453l-.206-4.724a10.406,10.406,0,0,1-4.309,1.129.425.425,0,0,1-.161-.031c-.145-.047-3.6-1.335-4.59-6.78l-.331-1.775c-1-5.283-2.125-11.273-.231-12.931,1.291-1.116,3.388-2.045,4.985-1.452a2.765,2.765,0,0,1,1.742,2.456,41.989,41.989,0,0,1,.161,5.814c-.031,2.234-.061,4.546.27,5.213a.645.645,0,0,0,.8.37c.7-.161,1.4-1.085,1.4-2.534a35.747,35.747,0,0,0-.676-5.889,26.667,26.667,0,0,1-.537-8.48c.576-3.931,3.01-5.72,4.96-5.62,1.728.039,3.9,1.536,4.3,5.606.353,3.555.515,7.447.515,12.246a.993.993,0,0,0,.506.86.579.579,0,0,0,.6.008c.156-.092.654-.554.554-2.265a6.235,6.235,0,0,1,2.142-5.161,3.329,3.329,0,0,1,3.241-.554,1.98,1.98,0,0,1,1.143,1.177c1.513,3.4-.515,13.315-1.327,15.156-.915,2.05-5.361,2.7-6.858,2.857v5.038a.482.482,0,0,1-.462.476l-7.133.239Zm-.239-6.421a.454.454,0,0,1,.223.061.467.467,0,0,1,.253.392l.214,5,6.207-.209v-5a.485.485,0,0,1,.437-.479c1.575-.122,5.814-.79,6.5-2.334.868-1.959,2.635-11.47,1.335-14.388a1.064,1.064,0,0,0-.576-.654,2.369,2.369,0,0,0-2.365.4A5.325,5.325,0,0,0,101.27,28.4c.117,1.995-.476,2.8-1,3.133a1.546,1.546,0,0,1-1.566.017,1.948,1.948,0,0,1-1-1.691A121.125,121.125,0,0,0,97.194,17.7c-.339-3.45-1.967-4.715-3.372-4.746h-.061c-1.566,0-3.447,1.488-3.939,4.807a26.241,26.241,0,0,0,.537,8.179,36.389,36.389,0,0,1,.693,6.051c0,2.034-1.107,3.216-2.128,3.461a1.628,1.628,0,0,1-1.867-.865c-.445-.885-.406-3.1-.376-5.661a42.375,42.375,0,0,0-.145-5.659A1.926,1.926,0,0,0,85.4,21.563c-1.152-.415-2.941.331-4.023,1.282-1.491,1.3-.317,7.5.537,12.04l.331,1.775c.821,4.515,3.425,5.82,3.909,6.029a10.539,10.539,0,0,0,4.415-1.352.461.461,0,0,1,.245-.07",
    transform: "translate(136.729 -12.001)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276444",
    "data-name": "Path 276444",
    d: "M84.759,22.182a.482.482,0,0,1-.476-.437s-.061-.754-.147-1.95a.49.49,0,0,1,.448-.509h.031a.485.485,0,0,1,.476.445c.083,1.185.145,1.936.145,1.936a.479.479,0,0,1-.437.515Z",
    transform: "translate(144.597 0.982)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276445",
    "data-name": "Path 276445",
    d: "M85.022,29.41a.483.483,0,0,1-.476-.445c-.345-4.86-.668-9.615-.746-11.473-.131-3.472,1.583-4.7,1.658-4.752a.477.477,0,0,1,.545.782c-.07.047-1.358,1.038-1.252,3.939.086,2.089.531,8.41.746,11.442a.482.482,0,0,1-.445.506Z",
    transform: "translate(143.989 -10.831)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276446",
    "data-name": "Path 276446",
    d: "M85.991,25.605a.482.482,0,0,1-.476-.462l-.245-7.962a.478.478,0,0,1,.459-.492h.017a.482.482,0,0,1,.476.462l.245,7.962a.479.479,0,0,1-.459.492Z",
    transform: "translate(146.62 -3.646)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276447",
    "data-name": "Path 276447",
    d: "M86.4,22.5a.476.476,0,1,1,0-.951,11.124,11.124,0,0,0,1.589-.139.275.275,0,0,1,.078-.008.476.476,0,0,1,.078.946A11.991,11.991,0,0,1,86.4,22.5",
    transform: "translate(147.78 4.76)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276448",
    "data-name": "Path 276448",
    d: "M87.706,30.372a.488.488,0,0,1-.431-.275.47.47,0,0,1,.231-.632,2.384,2.384,0,0,0,.89-.637c1.015-1.2.99-5.9.985-7.9v-.476a7.7,7.7,0,0,1,.913-3.611.452.452,0,0,1,.645-.167.473.473,0,0,1,.178.645,6.877,6.877,0,0,0-.784,3.133v.467c.017,3.664-.122,7.228-1.2,8.524a3.444,3.444,0,0,1-1.227.882.479.479,0,0,1-.2.047",
    transform: "translate(150.112 -3.8)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276449",
    "data-name": "Path 276449",
    d: "M85.5,25.945a3.936,3.936,0,0,1-2.465-.876c-.851-.659-1.536-1.933-2.134-4.014a.461.461,0,0,1,.323-.584.484.484,0,0,1,.581.323,7.1,7.1,0,0,0,1.814,3.525,3.045,3.045,0,0,0,3.647.122.46.46,0,0,1,.659.092.466.466,0,0,1-.083.659,4.052,4.052,0,0,1-2.342.754",
    transform: "translate(138.791 3.056)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276450",
    "data-name": "Path 276450",
    d: "M81.953,27.018a.474.474,0,0,1-.467-.376c-.231-1.121-.44-2.281-.632-3.388-.167-.935-.323-1.825-.49-2.64-.362-1.819-.2-3.163.484-3.992a2.134,2.134,0,0,1,1.55-.8.477.477,0,0,1,.476.476.47.47,0,0,1-.467.476,1.178,1.178,0,0,0-.837.459c-.331.423-.645,1.313-.27,3.2.161.812.323,1.719.492,2.657.192,1.1.392,2.251.629,3.355a.479.479,0,0,1-.367.568.441.441,0,0,1-.1.008",
    transform: "translate(137.544 -5.189)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276451",
    "data-name": "Path 276451",
    d: "M85.016,27.723a.475.475,0,0,1-.476-.431l-.484-5.183a.485.485,0,0,1,.431-.52h.044a.475.475,0,0,1,.476.428l.484,5.183a.487.487,0,0,1-.428.523Z",
    transform: "translate(144.454 5.086)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276452",
    "data-name": "Path 276452",
    d: "M102.364,23.8,101.5,30.9l-.59,4.832-.684,5.62H83.115l-.684-5.62-.59-4.832L80.976,23.8Z",
    transform: "translate(138.968 9.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276453",
    "data-name": "Path 276453",
    d: "M100.53,42.128H83.421a.466.466,0,0,1-.467-.423L80.811,24.168a.44.44,0,0,1,.114-.376.462.462,0,0,1,.353-.161h21.394a.462.462,0,0,1,.353.161.44.44,0,0,1,.114.376L101,41.706a.464.464,0,0,1-.467.423m-16.686-.951h16.263l2.028-16.595H81.816Z",
    transform: "translate(138.663 8.725)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276454",
    "data-name": "Path 276454",
    d: "M100.944,26.353l-.59,4.832H81.876l-.59-4.832Z",
    transform: "translate(139.522 13.575)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276455",
    "data-name": "Path 276455",
    d: "M100.657,31.963H82.181a.465.465,0,0,1-.467-.415l-.593-4.83a.451.451,0,0,1,.117-.376.462.462,0,0,1,.353-.161h19.658a.466.466,0,0,1,.353.161.44.44,0,0,1,.114.376l-.59,4.83a.468.468,0,0,1-.47.415M82.6,31.012h17.632l.476-3.878H82.129Z",
    transform: "translate(139.218 13.271)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25534",
    "data-name": "Rectangle 25534",
    width: 109.816,
    height: 7.272,
    transform: "translate(140.911 50.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276456",
    "data-name": "Path 276456",
    d: "M162.69,38.165H52.871a.479.479,0,0,1-.476-.476V30.417a.479.479,0,0,1,.476-.476H162.69a.479.479,0,0,1,.476.476v7.272a.479.479,0,0,1-.476.476M53.349,37.213H162.214V30.892H53.349Z",
    transform: "translate(88.037 19.969)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25535",
    "data-name": "Rectangle 25535",
    width: 25.316,
    height: 7.272,
    transform: "translate(225.411 50.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276457",
    "data-name": "Path 276457",
    d: "M108.564,38.165H83.245a.477.477,0,0,1-.476-.476V30.417a.477.477,0,0,1,.476-.476h25.319a.479.479,0,0,1,.476.476v7.272a.479.479,0,0,1-.476.476M83.72,37.213h24.365V30.892H83.72Z",
    transform: "translate(142.163 19.969)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276458",
    "data-name": "Path 276458",
    d: "M82.056,32.735c11.762,4.343,9.64,12.536,9.64,12.536H102.84V32.735Z",
    transform: "translate(140.893 24.948)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276459",
    "data-name": "Path 276459",
    d: "M103.141,46.054H92a.488.488,0,0,1-.378-.184.457.457,0,0,1-.083-.406c.083-.323,1.85-7.84-9.339-11.979a.471.471,0,0,1-.306-.531.477.477,0,0,1,.467-.389h20.781a.479.479,0,0,1,.476.476V45.578a.479.479,0,0,1-.476.476M92.559,45.1h10.1V33.515H84.711c8.009,3.848,8.057,9.715,7.848,11.587",
    transform: "translate(140.589 24.643)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276460",
    "data-name": "Path 276460",
    d: "M83.405,32.735c11.762,4.343,9.64,12.536,9.64,12.536h11.145V32.735Z",
    transform: "translate(143.297 24.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276461",
    "data-name": "Path 276461",
    d: "M104.5,46.054H93.352a.487.487,0,0,1-.376-.184.457.457,0,0,1-.083-.406c.075-.323,1.842-7.84-9.345-11.979a.472.472,0,0,1-.309-.531.478.478,0,0,1,.47-.389H104.5a.479.479,0,0,1,.476.476V45.578a.479.479,0,0,1-.476.476M93.914,45.1h10.1V33.515H86.058c8.009,3.848,8.065,9.715,7.856,11.587",
    transform: "translate(142.989 24.643)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276462",
    "data-name": "Path 276462",
    d: "M54.964,32.735c11.762,4.343,9.64,12.536,9.64,12.536H75.748V32.735Z",
    transform: "translate(92.615 24.948)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276463",
    "data-name": "Path 276463",
    d: "M76.056,46.054H64.914a.488.488,0,0,1-.378-.184.457.457,0,0,1-.083-.406c.075-.323,1.842-7.84-9.345-11.979a.472.472,0,0,1-.309-.531.478.478,0,0,1,.47-.389H76.056a.479.479,0,0,1,.476.476V45.578a.479.479,0,0,1-.476.476M65.473,45.1h10.1V33.515H57.617c8.009,3.848,8.065,9.715,7.856,11.587",
    transform: "translate(92.308 24.643)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276464",
    "data-name": "Path 276464",
    d: "M56.312,32.735c11.762,4.343,9.64,12.536,9.64,12.536H77.1V32.735Z",
    transform: "translate(95.017 24.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276465",
    "data-name": "Path 276465",
    d: "M77.4,46.054H66.26a.487.487,0,0,1-.376-.184.457.457,0,0,1-.083-.406c.075-.323,1.842-7.84-9.345-11.979a.472.472,0,0,1-.309-.531.478.478,0,0,1,.47-.389H77.4a.479.479,0,0,1,.476.476V45.578a.479.479,0,0,1-.476.476M66.822,45.1h10.1V33.515H58.966c8.009,3.848,8.065,9.715,7.856,11.587",
    transform: "translate(94.711 24.643)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25536",
    "data-name": "Rectangle 25536",
    width: 98.491,
    height: 136.726,
    transform: "translate(305.271 13.291)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276466",
    "data-name": "Path 276466",
    d: "M210.442,154.289H111.954a.48.48,0,0,1-.479-.476V17.082a.48.48,0,0,1,.479-.476h98.488a.48.48,0,0,1,.478.476V153.814a.48.48,0,0,1-.478.476m-98.012-.951h97.539V17.557H112.429Z",
    transform: "translate(193.317 -3.794)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25537",
    "data-name": "Rectangle 25537",
    width: 89.939,
    height: 124.856,
    transform: "translate(309.546 19.228)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87902",
    "data-name": "Group 87902",
    transform: "translate(309.546 19.228)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87901",
    "data-name": "Group 87901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87900",
    "data-name": "Group 87900",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25538",
    "data-name": "Rectangle 25538",
    width: 89.939,
    height: 124.856,
    transform: "translate(0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276467",
    "data-name": "Path 276467",
    d: "M196.523,144.553H117.362a.469.469,0,0,1-.453-.331.478.478,0,0,1,.175-.529,36.7,36.7,0,0,0,8.877-9.37.484.484,0,0,1,.662-.136.479.479,0,0,1,.136.659,38.087,38.087,0,0,1-7.984,8.755h77.273V19.691h-14.03c-.607.186-1.23.378-1.85.576C164,25.353,150.481,40.256,143.092,61.151a.459.459,0,0,1-.606.284.467.467,0,0,1-.284-.606c7.486-21.179,21.218-36.291,37.674-41.466.651-.209,1.3-.409,1.933-.6a.484.484,0,0,1,.139-.022h14.575a.477.477,0,0,1,.476.476V144.077a.477.477,0,0,1-.476.476",
    transform: "translate(202.96 0.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276468",
    "data-name": "Path 276468",
    d: "M121.289,102.468a.512.512,0,0,1-.231-.061.468.468,0,0,1-.184-.645c4.5-8.171,7.011-18.72,7.472-31.345a136.28,136.28,0,0,1,5.481-34.833.483.483,0,0,1,.593-.314.471.471,0,0,1,.314.593A135.815,135.815,0,0,0,129.3,70.447c-.467,12.778-3.018,23.466-7.595,31.776a.473.473,0,0,1-.415.245",
    transform: "translate(209.957 29.43)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276469",
    "data-name": "Path 276469",
    d: "M136.7,99.041a.486.486,0,0,1-.392-.2c-6.457-9.222-8.324-18.776-5.528-28.382,5.851-20.172,21.83-33.025,34.2-40.261a.472.472,0,1,1,.476.815c-12.216,7.15-28,19.841-33.771,39.707-2.7,9.322-.885,18.6,5.405,27.567a.49.49,0,0,1-.117.67.531.531,0,0,1-.275.083",
    transform: "translate(225.472 20.31)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276470",
    "data-name": "Path 276470",
    d: "M167.753,127.212h-6.182a.556.556,0,0,1-.223-.053c-8.393-4.51-20.089-11.879-28.2-21.393a.472.472,0,0,1,.053-.668.455.455,0,0,1,.668.053c7.987,9.361,19.521,16.639,27.828,21.11h5.583V29.7c-1.575.746-3.219,1.583-4.907,2.49a.478.478,0,0,1-.445-.846c1.942-1.043,3.839-2,5.628-2.827a.432.432,0,0,1,.453.031.472.472,0,0,1,.223.4v97.784a.477.477,0,0,1-.476.476",
    transform: "translate(231.73 17.349)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276471",
    "data-name": "Path 276471",
    d: "M113.489,76.808a.507.507,0,0,1-.145-.022.482.482,0,0,1-.331-.453V19.216a.477.477,0,0,1,.476-.476h21.769a.479.479,0,0,1,.476.423c.776,7,.217,18.383-6.863,32.811a.483.483,0,0,1-.637.223.475.475,0,0,1-.223-.637c6.849-13.943,7.517-24.954,6.819-31.868H113.964V74.819c3.386-4.913,7.088-10.827,11.028-17.616l.192-.331c.214-.384.437-.759.645-1.143a.462.462,0,0,1,.645-.184.471.471,0,0,1,.184.645c-.209.384-.431.768-.654,1.16l-.184.328c-4.293,7.395-8.31,13.762-11.94,18.929a.5.5,0,0,1-.392.2",
    transform: "translate(196.058 0.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276472",
    "data-name": "Path 276472",
    d: "M124.415,76.921c-4.952,0-8.838-7.687-8.838-17.5s3.886-17.49,8.838-17.49,8.838,7.687,8.838,17.49a.476.476,0,1,1-.951,0c0-9.122-3.541-16.539-7.887-16.539s-7.887,7.417-7.887,16.539,3.541,16.55,7.887,16.55c3.38,0,6.465-4.738,7.517-11.52a.48.48,0,0,1,.47-.406.184.184,0,0,1,.067.008.475.475,0,0,1,.4.537c-1.135,7.381-4.537,12.333-8.454,12.333",
    transform: "translate(200.627 41.332)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276473",
    "data-name": "Path 276473",
    d: "M124.362,47.217c-2.281,0-4.062-3.1-4.062-7.05s1.781-7.041,4.062-7.041,4.062,3.094,4.062,7.041-1.78,7.05-4.062,7.05m0-13.139c-1.689,0-3.11,2.788-3.11,6.09s1.422,6.1,3.11,6.1,3.11-2.793,3.11-6.1-1.422-6.09-3.11-6.09",
    transform: "translate(209.043 25.645)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276474",
    "data-name": "Path 276474",
    d: "M145.346,64.4c-7.18,0-13.022-4.37-13.022-9.737s5.842-9.729,13.022-9.729a17.348,17.348,0,0,1,3.38.328.478.478,0,0,1-.186.938,16.192,16.192,0,0,0-3.194-.314c-6.657,0-12.071,3.939-12.071,8.777s5.414,8.786,12.071,8.786,12.063-3.939,12.063-8.786c0-2.963-2.042-5.714-5.467-7.35a.475.475,0,0,1-.223-.637.488.488,0,0,1,.637-.223c3.764,1.8,6.006,4.868,6.006,8.21,0,5.366-5.837,9.737-13.017,9.737",
    transform: "translate(230.47 46.688)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276475",
    "data-name": "Path 276475",
    d: "M140.68,55.583c-3.163,0-5.737-1.959-5.737-4.362s2.573-4.354,5.737-4.354,5.736,1.95,5.736,4.354-2.573,4.362-5.736,4.362m0-7.765c-2.643,0-4.785,1.527-4.785,3.4s2.142,3.408,4.785,3.408,4.785-1.527,4.785-3.408-2.142-3.4-4.785-3.4",
    transform: "translate(235.137 50.131)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276476",
    "data-name": "Path 276476",
    d: "M144.1,49.55c-3.886,0-7.05-2.626-7.05-5.851s3.163-5.851,7.05-5.851,7.05,2.626,7.05,5.851-3.163,5.851-7.05,5.851m0-10.75c-3.363,0-6.1,2.195-6.1,4.9s2.735,4.9,6.1,4.9,6.1-2.195,6.1-4.9-2.735-4.9-6.1-4.9",
    transform: "translate(238.884 34.061)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276477",
    "data-name": "Path 276477",
    d: "M128.046,44.155c-2.779,0-4.952-5.06-4.952-11.526S125.267,21.1,128.046,21.1,133,26.163,133,32.629s-2.173,11.526-4.952,11.526m0-22.1c-1.936,0-4,4.245-4,10.574s2.064,10.574,4,10.574,4-4.248,4-10.574-2.064-10.574-4-10.574",
    transform: "translate(214.022 4.22)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276478",
    "data-name": "Path 276478",
    d: "M131.344,70.454a6.749,6.749,0,1,1,6.749-6.749,6.752,6.752,0,0,1-6.749,6.749m0-12.547a5.8,5.8,0,1,0,5.8,5.8,5.808,5.808,0,0,0-5.8-5.8",
    transform: "translate(216.697 68.11)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276479",
    "data-name": "Path 276479",
    d: "M141.188,33.04a4.358,4.358,0,1,1,4.362-4.362,4.362,4.362,0,0,1-4.362,4.362m0-7.765a3.405,3.405,0,1,0,3.411,3.4,3.408,3.408,0,0,0-3.411-3.4",
    transform: "translate(238.506 9.96)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276480",
    "data-name": "Path 276480",
    d: "M131.89,39.973a2.565,2.565,0,1,1,2.565-2.565,2.571,2.571,0,0,1-2.565,2.565m0-4.179a1.612,1.612,0,1,0,1.614,1.614,1.618,1.618,0,0,0-1.614-1.614",
    transform: "translate(225.111 28.704)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276481",
    "data-name": "Path 276481",
    d: "M203.425,144.553H113.489a.48.48,0,0,1-.476-.479V19.216a.477.477,0,0,1,.476-.476h89.936a.477.477,0,0,1,.476.476V144.074a.48.48,0,0,1-.476.479m-89.46-.954h88.985V19.691H113.964Z",
    transform: "translate(196.058 0.009)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25540",
    "data-name": "Rectangle 25540",
    width: 24.429,
    height: 9.197,
    transform: "translate(228.065 197.255)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276482",
    "data-name": "Path 276482",
    d: "M108.626,92.884H84.2a.477.477,0,0,1-.476-.476v-9.2a.477.477,0,0,1,.476-.476h24.426a.48.48,0,0,1,.479.476v9.2a.48.48,0,0,1-.479.476m-23.95-.951H108.15V83.684H84.675Z",
    transform: "translate(143.865 114.044)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276483",
    "data-name": "Path 276483",
    d: "M166.754,131.687H69.507l4.6-75.378h97.247Z",
    transform: "translate(118.53 66.957)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276484",
    "data-name": "Path 276484",
    d: "M167.059,132.467H69.811a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353l4.607-75.375a.478.478,0,0,1,.476-.448h97.247a.489.489,0,0,1,.476.509l-4.607,75.375a.477.477,0,0,1-.476.445m-96.741-.951h96.293l4.546-74.424H74.863Z",
    transform: "translate(118.223 66.652)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276485",
    "data-name": "Path 276485",
    d: "M165.751,131.687H68.5l4.6-75.378h97.247Z",
    transform: "translate(116.742 66.957)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276486",
    "data-name": "Path 276486",
    d: "M166.057,132.467H68.809a.462.462,0,0,1-.345-.153.451.451,0,0,1-.131-.353l4.6-75.375a.48.48,0,0,1,.476-.448h97.247a.489.489,0,0,1,.476.509l-4.6,75.375a.477.477,0,0,1-.476.445m-96.741-.951h96.293l4.54-74.424h-96.3Z",
    transform: "translate(116.438 66.652)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276487",
    "data-name": "Path 276487",
    d: "M156.979,124.818H70.537l4.092-67h86.442Z",
    transform: "translate(120.366 69.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276488",
    "data-name": "Path 276488",
    d: "M157.285,125.6H70.843a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353l4.084-67.007a.48.48,0,0,1,.476-.445h86.442a.473.473,0,0,1,.348.153.458.458,0,0,1,.128.353l-4.084,67.007a.477.477,0,0,1-.476.445M71.35,124.65H156.84l4.023-66.056H75.372Z",
    transform: "translate(120.062 69.334)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276489",
    "data-name": "Path 276489",
    d: "M130.186,111.385H71.464l3.155-51.637h58.722Z",
    transform: "translate(122.017 73.085)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276490",
    "data-name": "Path 276490",
    d: "M130.488,112.162H71.768a.462.462,0,0,1-.345-.153.451.451,0,0,1-.131-.353l3.155-51.634a.479.479,0,0,1,.476-.445h58.722a.485.485,0,0,1,.476.506l-3.155,51.634a.48.48,0,0,1-.479.445m-58.213-.951h57.768l3.1-50.682H75.368Z",
    transform: "translate(121.711 72.78)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276491",
    "data-name": "Path 276491",
    d: "M89.257,70.574S77.03,75.42,76.949,76.725s-2.47,16.033-2.47,16.033h36.352l-3.066-16.965L94.312,70.2Z",
    transform: "translate(127.39 91.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276492",
    "data-name": "Path 276492",
    d: "M111.135,93.535H74.785a.477.477,0,0,1-.47-.551C75.136,87.9,76.719,78.009,76.78,77c.078-1.321,6.9-4.3,12.6-6.565a.579.579,0,0,1,.145-.031l5.052-.37a.521.521,0,0,1,.223.039l13.454,5.589a.488.488,0,0,1,.287.353L111.6,92.976a.52.52,0,0,1-.1.392.5.5,0,0,1-.37.167m-35.79-.951h35.223l-2.918-16.149L94.543,70.99l-4.877.353c-5.575,2.22-11.551,4.977-11.949,5.775-.061,1.129-1.936,12.739-2.373,15.465",
    transform: "translate(127.087 91.407)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276493",
    "data-name": "Path 276493",
    d: "M82.908,69.316a6.422,6.422,0,0,0-2.5,1.3c-.988.932-2.114,4.1-2.114,4.1l-.042,3.728,4.821-2.609,4.868-.373,4.585,4.287.587-6.524S92.4,69.5,90.923,69.316s-8.015,0-8.015,0",
    transform: "translate(134.107 89.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276494",
    "data-name": "Path 276494",
    d: "M92.829,80.536a.464.464,0,0,1-.323-.128l-4.432-4.14-4.56.353L78.777,79.17a.473.473,0,0,1-.7-.423l.047-3.722a.389.389,0,0,1,.031-.156c.114-.328,1.191-3.308,2.234-4.284A6.743,6.743,0,0,1,83.1,69.166a.443.443,0,0,1,.1-.017c.267-.014,6.588-.2,8.093.008,1.736.214,2.456,3.617,2.587,4.3a.617.617,0,0,1,.008.128L93.3,80.108a.488.488,0,0,1-.306.4.415.415,0,0,1-.17.031M88.244,75.3a.457.457,0,0,1,.323.131l3.878,3.617.492-5.483c-.27-1.366-1-3.372-1.767-3.469-1.338-.161-7.25-.017-7.887.006a5.8,5.8,0,0,0-2.242,1.177,13.375,13.375,0,0,0-1.967,3.839l-.039,2.84,4.117-2.22a.435.435,0,0,1,.184-.061l4.868-.376Z",
    transform: "translate(133.8 89.678)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276495",
    "data-name": "Path 276495",
    d: "M80,67.99l-.211,6.524,2.885,4.66,4.768-4.846.737-5.965Z",
    transform: "translate(136.857 87.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276496",
    "data-name": "Path 276496",
    d: "M82.982,79.954H82.93a.5.5,0,0,1-.353-.225l-2.888-4.66a.542.542,0,0,1-.07-.27l.214-6.518a.487.487,0,0,1,.153-.331.67.67,0,0,1,.348-.131l8.176.37a.5.5,0,0,1,.342.17.45.45,0,0,1,.1.367l-.737,5.967a.393.393,0,0,1-.128.267l-4.771,4.846a.485.485,0,0,1-.337.147m-2.4-5.269,2.484,4.023L87.3,74.415l.654-5.3-7.18-.323Z",
    transform: "translate(136.55 87.467)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276497",
    "data-name": "Path 276497",
    d: "M93.353,71.591c-.334,5.469-3.97,12.1-7.956,12.1s-6.81-6.629-6.476-12.1,3.836-9.9,7.82-9.9,6.947,4.432,6.613,9.9",
    transform: "translate(135.257 76.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276498",
    "data-name": "Path 276498",
    d: "M85.7,84.469a4.976,4.976,0,0,1-3.594-1.758c-2.22-2.365-3.6-6.827-3.355-10.841.345-5.706,4.062-10.352,8.3-10.352A6.068,6.068,0,0,1,91.52,63.56a11.372,11.372,0,0,1,2.612,8.371c-.348,5.681-4.187,12.538-8.432,12.538m1.346-22c-3.733,0-7.03,4.245-7.342,9.462-.231,3.717,1.074,7.979,3.1,10.135a4.018,4.018,0,0,0,2.9,1.452c3.647,0,7.164-6.4,7.478-11.648a10.327,10.327,0,0,0-2.356-7.656,5.1,5.1,0,0,0-3.775-1.744",
    transform: "translate(134.953 76.239)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276499",
    "data-name": "Path 276499",
    d: "M80.092,66.625S78.8,63.27,78.27,65.88s2.1,5.405,2.1,5.405Z",
    transform: "translate(134.021 82.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276500",
    "data-name": "Path 276500",
    d: "M80.673,72.061a.462.462,0,0,1-.345-.153c-.114-.114-2.788-3-2.22-5.82.078-.362.27-1.313.985-1.374h.061c.782,0,1.388,1.266,1.689,2.042a1.251,1.251,0,0,1,.031.139l.275,4.66a.493.493,0,0,1-.284.47.586.586,0,0,1-.192.036m-1.466-6.326a1.978,1.978,0,0,0-.161.537,5.448,5.448,0,0,0,1.06,3.786l-.178-3.032a5.365,5.365,0,0,0-.721-1.291",
    transform: "translate(133.716 81.934)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276501",
    "data-name": "Path 276501",
    d: "M84.711,65.45s3.149-1.324,2.231,1.472a5.536,5.536,0,0,1-3.2,3.541Z",
    transform: "translate(143.899 82.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276502",
    "data-name": "Path 276502",
    d: "M84.047,71.246a.448.448,0,0,1-.314-.125.477.477,0,0,1-.153-.445l.968-5.013a.476.476,0,0,1,.284-.345c.306-.131,1.864-.723,2.657.006.453.417.52,1.107.214,2.05a5.982,5.982,0,0,1-3.508,3.848.455.455,0,0,1-.147.025m1.383-5.138L84.7,69.9A5.316,5.316,0,0,0,86.8,67.084c.178-.531.192-.929.047-1.06-.223-.209-.89-.092-1.413.083",
    transform: "translate(143.594 82.385)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276503",
    "data-name": "Path 276503",
    d: "M84.437,67.183a2.427,2.427,0,0,0-2.451-2.61,2.81,2.81,0,0,0-2.768,2.61,2.425,2.425,0,0,0,2.451,2.609,2.812,2.812,0,0,0,2.768-2.609",
    transform: "translate(135.827 81.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276504",
    "data-name": "Path 276504",
    d: "M81.972,70.568a2.92,2.92,0,0,1-2.927-3.116A3.306,3.306,0,0,1,82.294,64.4a2.924,2.924,0,0,1,2.142.9,2.964,2.964,0,0,1,.785,2.206,3.3,3.3,0,0,1-3.249,3.055m.323-5.213A2.334,2.334,0,0,0,80,67.513a1.947,1.947,0,0,0,1.972,2.1,2.323,2.323,0,0,0,2.3-2.164,1.934,1.934,0,0,0-1.972-2.1",
    transform: "translate(135.519 81.38)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276505",
    "data-name": "Path 276505",
    d: "M83.674,66.767a.473.473,0,0,1-.462-.353.482.482,0,0,1,.339-.584l2.84-.743a.461.461,0,0,1,.584.337.477.477,0,0,1-.339.584l-2.84.743a.679.679,0,0,1-.122.017",
    transform: "translate(142.925 82.569)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276506",
    "data-name": "Path 276506",
    d: "M86.715,67.183a2.427,2.427,0,0,0-2.451-2.61,2.81,2.81,0,0,0-2.768,2.61,2.425,2.425,0,0,0,2.451,2.609,2.812,2.812,0,0,0,2.768-2.609",
    transform: "translate(139.886 81.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276507",
    "data-name": "Path 276507",
    d: "M84.253,70.568a2.894,2.894,0,0,1-2.927-3.116A3.286,3.286,0,0,1,84.567,64.4a2.894,2.894,0,0,1,2.927,3.11,3.293,3.293,0,0,1-3.241,3.055m.314-5.213a2.325,2.325,0,0,0-2.29,2.159,1.951,1.951,0,0,0,1.975,2.1,2.321,2.321,0,0,0,2.287-2.164,1.937,1.937,0,0,0-1.972-2.1",
    transform: "translate(139.581 81.38)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276508",
    "data-name": "Path 276508",
    d: "M87,61.843s-2.89-1.491-5-.559-3.719,5.965-3.614,7.269a36.858,36.858,0,0,0,1.372,5.035l2.262-6.527,5.94-2.609Z",
    transform: "translate(134.351 75.276)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276509",
    "data-name": "Path 276509",
    d: "M80.067,74.36h0a.476.476,0,0,1-.451-.323,37.255,37.255,0,0,1-1.4-5.144c-.106-1.427,1.513-6.68,3.9-7.748,2.251-.99,5.277.515,5.408.576a.442.442,0,0,1,.228.261l.96,2.61a.477.477,0,0,1-.253.6l-5.742,2.526-2.2,6.318a.476.476,0,0,1-.448.323m3.825-12.608a3.463,3.463,0,0,0-1.391.27c-1.872.829-3.416,5.681-3.333,6.794a23.71,23.71,0,0,0,.915,3.58l1.805-5.183a.448.448,0,0,1,.253-.287L87.67,64.5l-.737-2.011a8.047,8.047,0,0,0-3.041-.737",
    transform: "translate(134.043 74.976)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276510",
    "data-name": "Path 276510",
    d: "M80.465,63.286s4.7-3.728,8.5-1.864a5.742,5.742,0,0,1,3.352,6.151c-.056.932-.131,5.219-.131,5.219l-2.259.373-1.091-3.541A32.755,32.755,0,0,1,85.1,67.849s-5.06-.648-4.635-4.562",
    transform: "translate(138.013 75.138)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276511",
    "data-name": "Path 276511",
    d: "M90.239,73.946a.464.464,0,0,1-.453-.337l-1.021-3.324a33.018,33.018,0,0,1-3.511-1.675c-1.928-.275-5.322-1.666-4.96-5.074a.51.51,0,0,1,.184-.323c.2-.156,5.021-3.864,9.008-1.92a6.153,6.153,0,0,1,3.625,6.5c-.061,1.021-.139,5.266-.139,5.305a.474.474,0,0,1-.4.459l-2.259.378a.34.34,0,0,1-.075.006m-9.016-10.1c-.17,3.224,4.062,3.809,4.245,3.839a.448.448,0,0,1,.17.053,32.137,32.137,0,0,0,3.678,1.744.464.464,0,0,1,.284.306l.968,3.149,1.461-.245c.022-1.082.075-4.062.122-4.846a5.253,5.253,0,0,0-3.08-5.689c-3.124-1.53-7,1.091-7.848,1.689",
    transform: "translate(137.704 74.836)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276512",
    "data-name": "Path 276512",
    d: "M81.3,65.511l-.331,5.405h1.3",
    transform: "translate(138.96 83.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276513",
    "data-name": "Path 276513",
    d: "M82.582,71.7h-1.3a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353l.328-5.405a.449.449,0,0,1,.506-.445.481.481,0,0,1,.448.506l-.3,4.9h.8a.476.476,0,0,1,0,.951",
    transform: "translate(138.656 83.047)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11047",
    "data-name": "Line 11047",
    x2: 2.796,
    transform: "translate(219.249 156.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276514",
    "data-name": "Path 276514",
    d: "M83.827,68.972h-2.8a.476.476,0,1,1,0-.951h2.8a.476.476,0,0,1,0,.951",
    transform: "translate(138.218 87.827)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276515",
    "data-name": "Path 276515",
    d: "M80.761,89.754h-.031a.478.478,0,0,1-.445-.506l1.035-16.965a.476.476,0,0,1,.479-.445h.031a.483.483,0,0,1,.445.509L81.237,89.309a.471.471,0,0,1-.476.445",
    transform: "translate(137.736 94.629)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276516",
    "data-name": "Path 276516",
    d: "M85.112,89.587h-.053a.488.488,0,0,1-.423-.529c.008-.039.437-4.109.554-5.945.114-1.9,3.647-9.882,4.045-10.789a.481.481,0,0,1,.632-.245.487.487,0,0,1,.245.629c-1.077,2.418-3.878,9.008-3.97,10.466-.117,1.85-.554,5.945-.554,5.99a.485.485,0,0,1-.476.423",
    transform: "translate(145.487 94.988)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276517",
    "data-name": "Path 276517",
    d: "M79.937,88.986H79.9a.479.479,0,0,1-.437-.515c.292-3.324.437-7.233.17-7.756-.484-.921-4.332-7.564-4.37-7.631a.48.48,0,0,1,.175-.654.5.5,0,0,1,.654.175c.153.278,3.886,6.727,4.384,7.664.523.977.086,6.588-.061,8.279a.476.476,0,0,1-.476.437",
    transform: "translate(128.67 95.589)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276518",
    "data-name": "Path 276518",
    d: "M87.377,82.491l1.285-5.778,2.187-2.237,2.07-3.358h.932L92.7,74.662l2.9-1.678L97.462,70l1.082.559-2.657,6.9-4.226,2.05-.732,2.8Z",
    transform: "translate(150.375 91.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276519",
    "data-name": "Path 276519",
    d: "M87.684,83.269a.478.478,0,0,1-.362-.167.447.447,0,0,1-.1-.409l1.283-5.773a.424.424,0,0,1,.122-.231l2.189-2.234,2-3.272a.468.468,0,0,1,.406-.231h.938a.479.479,0,0,1,.384.2.454.454,0,0,1,.067.42l-.768,2.359,1.722-1,1.8-2.879a.456.456,0,0,1,.615-.17l1.082.562a.47.47,0,0,1,.231.59l-2.657,6.9a.506.506,0,0,1-.236.262l-4.034,1.95-.673,2.587a.485.485,0,0,1-.44.353l-3.547.184ZM89.4,77.257l-1.121,5.03,2.579-.131.64-2.465a.487.487,0,0,1,.253-.306l4.062-1.967,2.434-6.326-.314-.161L96.3,73.54a.557.557,0,0,1-.161.161l-2.9,1.683a.489.489,0,0,1-.537-.047.473.473,0,0,1-.153-.515L93.5,71.9h-.017l-1.925,3.127Z",
    transform: "translate(150.073 91.046)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276520",
    "data-name": "Path 276520",
    d: "M93.312,86.191l.356-11.559-4.243-.746-3.35,12.3Z",
    transform: "translate(148.056 98.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276521",
    "data-name": "Path 276521",
    d: "M93.616,86.968H86.38A.487.487,0,0,1,86,86.785a.478.478,0,0,1-.083-.415l3.347-12.3a.478.478,0,0,1,.462-.353.312.312,0,0,1,.083.008l4.248.746a.47.47,0,0,1,.389.481l-.359,11.559a.48.48,0,0,1-.476.459M87,86.017h6.151l.331-10.68-3.411-.6Z",
    transform: "translate(147.75 97.974)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276522",
    "data-name": "Path 276522",
    d: "M130.092,82.6H71.37l.264-4.287h58.719Z",
    transform: "translate(121.849 106.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276523",
    "data-name": "Path 276523",
    d: "M130.394,83.381H71.674a.462.462,0,0,1-.345-.153.451.451,0,0,1-.131-.353l.262-4.293a.478.478,0,0,1,.476-.445h58.719a.462.462,0,0,1,.345.153.45.45,0,0,1,.131.353l-.259,4.293a.48.48,0,0,1-.479.445M72.181,82.43h57.768l.2-3.341H72.381Z",
    transform: "translate(121.543 105.854)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11048",
    "data-name": "Line 11048",
    x2: 53.873,
    transform: "translate(195.616 186.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276524",
    "data-name": "Path 276524",
    d: "M126.411,79.693H72.535a.476.476,0,1,1,0-.951h53.876a.476.476,0,1,1,0,.951",
    transform: "translate(123.078 106.932)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276525",
    "data-name": "Path 276525",
    d: "M114.3,73.42H94.542l.832-13.609h19.76Z",
    transform: "translate(163.142 73.197)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276526",
    "data-name": "Path 276526",
    d: "M114.607,74.2H94.846a.467.467,0,0,1-.345-.153.461.461,0,0,1-.131-.353L95.2,60.086a.476.476,0,0,1,.476-.445h19.763a.458.458,0,0,1,.345.153.463.463,0,0,1,.134.353l-.84,13.607a.475.475,0,0,1-.473.445m-19.251-.951h18.8l.776-12.655H96.12Z",
    transform: "translate(162.836 72.894)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276527",
    "data-name": "Path 276527",
    d: "M114.3,66.136H94.542l.136-2.237h19.76Z",
    transform: "translate(163.142 80.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276528",
    "data-name": "Path 276528",
    d: "M114.607,66.914H94.846a.467.467,0,0,1-.345-.153.461.461,0,0,1-.131-.353l.139-2.234a.476.476,0,0,1,.476-.445h19.758a.489.489,0,0,1,.479.506l-.142,2.234a.475.475,0,0,1-.473.445m-19.251-.951h18.8l.075-1.282h-18.8Z",
    transform: "translate(162.836 80.179)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276529",
    "data-name": "Path 276529",
    d: "M102.878,63.939l-5.133-3.071L97.37,67.01Z",
    transform: "translate(168.182 75.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276530",
    "data-name": "Path 276530",
    d: "M97.675,67.795a.458.458,0,0,1-.253-.078.48.48,0,0,1-.223-.431l.376-6.143a.5.5,0,0,1,.253-.392.455.455,0,0,1,.47.017l5.13,3.071a.474.474,0,0,1-.017.821l-5.506,3.071a.488.488,0,0,1-.231.064m.807-5.814-.275,4.5,4.023-2.248Z",
    transform: "translate(167.877 74.769)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276531",
    "data-name": "Path 276531",
    d: "M113.84,80.994H94.079l.832-13.609h19.76Z",
    transform: "translate(162.317 86.693)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276532",
    "data-name": "Path 276532",
    d: "M114.144,81.773H94.386a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353L94.74,67.66a.478.478,0,0,1,.476-.445h19.758a.485.485,0,0,1,.476.506l-.829,13.607a.476.476,0,0,1-.476.445m-19.251-.951H113.7l.768-12.655H95.66Z",
    transform: "translate(162.016 86.391)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276533",
    "data-name": "Path 276533",
    d: "M113.84,73.709H94.079l.136-2.237h19.76Z",
    transform: "translate(162.317 93.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276534",
    "data-name": "Path 276534",
    d: "M114.144,74.494H94.386a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353l.131-2.242a.478.478,0,0,1,.476-.445h19.766a.485.485,0,0,1,.476.506l-.139,2.242a.476.476,0,0,1-.476.445m-19.251-.951H113.7l.075-1.291H94.962Z",
    transform: "translate(162.016 93.67)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276535",
    "data-name": "Path 276535",
    d: "M102.416,71.513l-5.133-3.071-.376,6.143Z",
    transform: "translate(167.358 88.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276536",
    "data-name": "Path 276536",
    d: "M97.212,75.372a.458.458,0,0,1-.253-.078.48.48,0,0,1-.223-.431l.376-6.143a.5.5,0,0,1,.253-.392.437.437,0,0,1,.47.017l5.136,3.071a.471.471,0,0,1,.231.415.477.477,0,0,1-.245.406l-5.514,3.071a.489.489,0,0,1-.231.064m.807-5.814-.275,4.5,4.031-2.251Z",
    transform: "translate(167.052 88.266)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276537",
    "data-name": "Path 276537",
    d: "M113.377,88.568H93.617l.832-13.609h19.76Z",
    transform: "translate(161.493 100.19)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276538",
    "data-name": "Path 276538",
    d: "M113.68,89.353H93.922a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353l.829-13.615a.478.478,0,0,1,.476-.445h19.758a.485.485,0,0,1,.476.506l-.829,13.615a.476.476,0,0,1-.476.445M94.429,88.4h18.806L114,75.737H95.2Z",
    transform: "translate(161.189 99.882)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276539",
    "data-name": "Path 276539",
    d: "M113.377,81.283H93.617l.136-2.237h19.76Z",
    transform: "translate(161.493 107.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276540",
    "data-name": "Path 276540",
    d: "M113.68,82.068H93.922a.462.462,0,0,1-.345-.153.45.45,0,0,1-.131-.353l.136-2.242a.48.48,0,0,1,.478-.445h19.758a.485.485,0,0,1,.476.506l-.139,2.242a.476.476,0,0,1-.476.445m-19.251-.951h18.806l.075-1.291h-18.8Z",
    transform: "translate(161.189 107.167)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276541",
    "data-name": "Path 276541",
    d: "M101.953,79.087l-5.133-3.071-.376,6.143Z",
    transform: "translate(166.534 102.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276542",
    "data-name": "Path 276542",
    d: "M96.751,82.946a.458.458,0,0,1-.253-.078.48.48,0,0,1-.223-.431l.376-6.143A.5.5,0,0,1,96.9,75.9a.437.437,0,0,1,.47.017l5.13,3.071a.474.474,0,0,1-.017.821l-5.506,3.071a.489.489,0,0,1-.231.064m.807-5.814-.275,4.5,4.023-2.251Z",
    transform: "translate(166.23 101.762)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276543",
    "data-name": "Path 276543",
    d: "M114.063,66.289h-19.2a.476.476,0,0,1,0-.951h19.2a.476.476,0,1,1,0,.951",
    transform: "translate(162.87 83.046)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276544",
    "data-name": "Path 276544",
    d: "M114.014,67.1h-19.2a.476.476,0,1,1,0-.951h19.2a.476.476,0,0,1,0,.951",
    transform: "translate(162.783 84.482)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276545",
    "data-name": "Path 276545",
    d: "M113.6,73.93H94.4a.476.476,0,1,1,0-.951h19.2a.476.476,0,0,1,0,.951",
    transform: "translate(162.039 96.662)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276546",
    "data-name": "Path 276546",
    d: "M113.547,74.733h-19.2a.476.476,0,1,1,0-.951h19.2a.476.476,0,0,1,0,.951",
    transform: "translate(161.95 98.093)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276547",
    "data-name": "Path 276547",
    d: "M100.262,89.686H85.851a5.425,5.425,0,0,1,5.425-5.425h3.561a5.425,5.425,0,0,1,5.425,5.425",
    transform: "translate(147.655 116.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276548",
    "data-name": "Path 276548",
    d: "M100.564,90.465h-14.4a.48.48,0,0,1-.481-.476,5.912,5.912,0,0,1,5.9-5.9h3.564a5.91,5.91,0,0,1,5.9,5.9.477.477,0,0,1-.476.476m-13.9-.951h13.4a4.948,4.948,0,0,0-4.921-4.468H91.578a4.948,4.948,0,0,0-4.919,4.468",
    transform: "translate(147.351 116.464)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25541",
    "data-name": "Rectangle 25541",
    width: 70.582,
    height: 2.96,
    transform: "translate(156.02 203.493)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276549",
    "data-name": "Path 276549",
    d: "M128.882,88.886H58.306a.48.48,0,0,1-.478-.476V85.453a.482.482,0,0,1,.478-.476h70.576a.479.479,0,0,1,.476.476V88.41a.477.477,0,0,1-.476.476m-70.1-.951h69.625v-2H58.781Z",
    transform: "translate(97.717 118.043)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25542",
    "data-name": "Rectangle 25542",
    width: 17.735,
    height: 2.96,
    transform: "translate(208.85 203.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276550",
    "data-name": "Path 276550",
    d: "M95.023,88.886H77.294a.477.477,0,0,1-.476-.476V85.453a.479.479,0,0,1,.476-.476h17.73a.481.481,0,0,1,.478.476V88.41a.48.48,0,0,1-.478.476m-17.254-.951H94.548v-2H77.769Z",
    transform: "translate(131.559 118.043)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276551",
    "data-name": "Path 276551",
    d: "M93.729,93.3l8.535,115.391a1.662,1.662,0,0,0,3.319-.142L104.323,93.3Z",
    transform: "translate(161.694 132.876)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276552",
    "data-name": "Path 276552",
    d: "M104.226,211.009a2.157,2.157,0,0,1-2.134-1.972L93.56,93.646a.468.468,0,0,1,.131-.362.45.45,0,0,1,.345-.153h10.588a.473.473,0,0,1,.478.467l1.257,115.247a2.137,2.137,0,0,1-2.134,2.164M94.55,94.082l8.493,114.877a1.193,1.193,0,0,0,1.182,1.1,1.178,1.178,0,0,0,1.182-1.2L104.156,94.082Z",
    transform: "translate(161.39 132.573)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276553",
    "data-name": "Path 276553",
    d: "M96.05,93.3l4.524,116.724a1.658,1.658,0,0,0,.874-1.474L100.187,93.3Z",
    transform: "translate(165.83 132.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276554",
    "data-name": "Path 276554",
    d: "M100.871,210.8a.542.542,0,0,1-.237-.061.5.5,0,0,1-.239-.4L95.881,93.621a.471.471,0,0,1,.476-.49h4.131a.47.47,0,0,1,.476.467l1.26,115.247a2.13,2.13,0,0,1-1.13,1.9.548.548,0,0,1-.223.056M96.849,94.082l4.415,114.087L100.02,94.082Z",
    transform: "translate(165.526 132.573)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276555",
    "data-name": "Path 276555",
    d: "M113.068,93.3,121.6,208.692a1.662,1.662,0,0,0,3.319-.142L123.662,93.3Z",
    transform: "translate(196.156 132.876)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276556",
    "data-name": "Path 276556",
    d: "M123.564,211.009a2.157,2.157,0,0,1-2.134-1.972L112.9,93.646a.468.468,0,0,1,.131-.362.45.45,0,0,1,.345-.153h10.588a.473.473,0,0,1,.478.467L125.7,208.845a2.116,2.116,0,0,1-.606,1.527,2.156,2.156,0,0,1-1.527.637M113.888,94.082l8.493,114.877a1.193,1.193,0,0,0,1.182,1.1,1.164,1.164,0,0,0,.846-.353,1.145,1.145,0,0,0,.337-.846L123.494,94.082Z",
    transform: "translate(195.85 132.573)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276557",
    "data-name": "Path 276557",
    d: "M115.207,93.3l5.275,116.56a1.655,1.655,0,0,0,.626-1.31L119.847,93.3Z",
    transform: "translate(199.967 132.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276558",
    "data-name": "Path 276558",
    d: "M120.789,210.642a.548.548,0,0,1-.192-.039.477.477,0,0,1-.284-.414l-5.277-116.56a.506.506,0,0,1,.131-.353.493.493,0,0,1,.348-.145h4.638a.47.47,0,0,1,.476.467l1.26,115.247a2.163,2.163,0,0,1-.8,1.689.48.48,0,0,1-.3.109m-4.777-116.56,4.838,106.906L119.682,94.082Z",
    transform: "translate(199.662 132.573)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276559",
    "data-name": "Path 276559",
    d: "M69.714,93.961,61.132,208.095a1.662,1.662,0,0,1-3.319-.142L59.084,93.638Z",
    transform: "translate(97.692 133.476)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276560",
    "data-name": "Path 276560",
    d: "M59.776,210.419a2.137,2.137,0,0,1-2.134-2.164L58.908,93.946a.486.486,0,0,1,.147-.339c.1-.083.262-.175.345-.131l10.636.323a.481.481,0,0,1,.339.161.5.5,0,0,1,.122.353L61.913,208.447a2.16,2.16,0,0,1-2.137,1.972m.078-115.976-1.26,113.825a1.186,1.186,0,0,0,.339.846,1.154,1.154,0,0,0,.843.353,1.193,1.193,0,0,0,1.182-1.1L69.507,94.736Z",
    transform: "translate(97.387 133.166)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276561",
    "data-name": "Path 276561",
    d: "M50.375,93.961,41.793,208.095a1.662,1.662,0,0,1-3.319-.142L39.745,93.638Z",
    transform: "translate(63.23 133.476)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276562",
    "data-name": "Path 276562",
    d: "M40.438,210.412a2.156,2.156,0,0,1-1.527-.637,2.128,2.128,0,0,1-.606-1.527L39.57,93.938a.475.475,0,0,1,.479-.47h.014l10.627.323a.481.481,0,0,1,.339.161.487.487,0,0,1,.122.353L42.575,208.439a2.16,2.16,0,0,1-2.137,1.972m.078-115.976-1.26,113.825a1.183,1.183,0,0,0,1.182,1.2,1.193,1.193,0,0,0,1.182-1.1L50.161,94.728Z",
    transform: "translate(62.927 133.174)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25543",
    "data-name": "Rectangle 25543",
    width: 223.143,
    height: 17.977,
    transform: "translate(99.821 209.137)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276563",
    "data-name": "Path 276563",
    d: "M261.244,105.935H38.1a.477.477,0,0,1-.476-.476V87.482a.477.477,0,0,1,.476-.476H261.244a.477.477,0,0,1,.476.476v17.977a.477.477,0,0,1-.476.476m-222.668-.951H260.768V87.96H38.576Z",
    transform: "translate(61.717 121.658)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25544",
    "data-name": "Rectangle 25544",
    width: 63.95,
    height: 17.977,
    transform: "translate(259.017 209.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276564",
    "data-name": "Path 276564",
    d: "M159.268,105.935H95.327a.477.477,0,0,1-.476-.476V87.482a.477.477,0,0,1,.476-.476h63.941a.477.477,0,0,1,.476.476v17.977a.477.477,0,0,1-.476.476M95.8,104.983h62.99V87.96H95.8Z",
    transform: "translate(163.693 121.658)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25545",
    "data-name": "Rectangle 25545",
    width: 223.143,
    height: 4.952,
    transform: "translate(99.821 211.989)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276565",
    "data-name": "Path 276565",
    d: "M261.244,93.936H38.1a.479.479,0,0,1-.476-.476V88.506a.477.477,0,0,1,.476-.476H261.244a.477.477,0,0,1,.476.476V93.46a.479.479,0,0,1-.476.476M38.576,92.982H260.768v-4H38.576Z",
    transform: "translate(61.717 123.483)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25546",
    "data-name": "Rectangle 25546",
    width: 229.573,
    height: 6.006,
    transform: "translate(96.607 206.561)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276566",
    "data-name": "Path 276566",
    d: "M266.519,93.034H36.95a.48.48,0,0,1-.479-.476v-6a.48.48,0,0,1,.479-.476h229.57a.477.477,0,0,1,.476.476v6a.477.477,0,0,1-.476.476M37.425,92.083H266.044V87.03H37.425Z",
    transform: "translate(59.661 120.006)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25547",
    "data-name": "Rectangle 25547",
    width: 63.045,
    height: 6.006,
    transform: "translate(263.132 206.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276567",
    "data-name": "Path 276567",
    d: "M159.851,93.034H96.806a.477.477,0,0,1-.476-.476v-6a.477.477,0,0,1,.476-.476h63.045a.477.477,0,0,1,.476.476v6a.477.477,0,0,1-.476.476m-62.57-.951h62.091V87.03H97.281Z",
    transform: "translate(166.329 120.006)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276568",
    "data-name": "Path 276568",
    d: "M118.578,46.194H87.592a6.087,6.087,0,0,0-6.087,6.087V63.715A6.085,6.085,0,0,0,87.592,69.8h16.227l-6.084,16.97L109.381,69.8h9.2a6.087,6.087,0,0,0,6.087-6.087V52.281a6.088,6.088,0,0,0-6.087-6.087",
    transform: "translate(139.911 48.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276569",
    "data-name": "Path 276569",
    d: "M98.043,87.557a.452.452,0,0,1-.214-.053.472.472,0,0,1-.231-.584l5.851-16.333H87.9a6.578,6.578,0,0,1-6.566-6.565V52.588A6.578,6.578,0,0,1,87.9,46.022h30.986a6.578,6.578,0,0,1,6.566,6.565V64.021a6.578,6.578,0,0,1-6.566,6.565h-8.947l-11.5,16.761a.483.483,0,0,1-.392.209M87.9,46.973a5.621,5.621,0,0,0-5.614,5.614V64.021A5.621,5.621,0,0,0,87.9,69.633h16.225a.494.494,0,0,1,.392.2.484.484,0,0,1,.053.44L99.734,83.779l9.559-13.938a.472.472,0,0,1,.392-.209h9.2a5.618,5.618,0,0,0,5.611-5.611V52.588a5.619,5.619,0,0,0-5.611-5.614Z",
    transform: "translate(139.606 48.625)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276570",
    "data-name": "Path 276570",
    d: "M89.909,51.988A2.213,2.213,0,1,0,87.695,54.2a2.215,2.215,0,0,0,2.214-2.214",
    transform: "translate(147 55.311)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276571",
    "data-name": "Path 276571",
    d: "M92.893,51.988A2.213,2.213,0,1,0,90.679,54.2a2.215,2.215,0,0,0,2.214-2.214",
    transform: "translate(152.317 55.311)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276572",
    "data-name": "Path 276572",
    d: "M95.876,51.988A2.213,2.213,0,1,0,93.662,54.2a2.215,2.215,0,0,0,2.214-2.214",
    transform: "translate(157.633 55.311)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276573",
    "data-name": "Path 276573",
    d: "M173.7,136.2H148.025a.476.476,0,1,1,0-.951H173.7a.476.476,0,1,1,0,.951",
    transform: "translate(257.6 207.629)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276574",
    "data-name": "Path 276574",
    d: "M394.227,136.2H2.392a.476.476,0,1,1,0-.951H394.227a.476.476,0,1,1,0,.951",
    transform: "translate(-1.916 207.629)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276575",
    "data-name": "Path 276575",
    d: "M74.484,103.995C71.7,99.254,63.5,80.941,63.5,80.941A37.849,37.849,0,0,1,64.7,75.148c.682-1.872,2.384-7.664,2.042-8.855s-5.28-3.405-5.789-3.578.682-3.066-1.193-3.745-2.554.339-2.554.339L56.5,64.059l-2.189,3.425a28.7,28.7,0,0,0-2.893-1.872c-1.533-.851-5.111-1.193-5.28.17s2.9,2.554,3.917,3.408,2.384,4.938,3.575,6.129a43.4,43.4,0,0,1,3.066,3.747l.682,2.214s2.334,22.437,2.612,28.012,1.116,20.353,2.79,22.584,1.95,3.625,6.691,1.953,5.575-3.9,6.691-8.922,1.116-16.172-1.672-20.912",
    transform: "translate(76.865 71.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276576",
    "data-name": "Path 276576",
    d: "M66.472,135.348c-1.614,0-2.329-.862-3.288-2.212-.153-.217-.314-.44-.49-.676-1.544-2.059-2.42-13.562-2.879-22.846-.278-5.5-2.6-27.759-2.621-27.99l-.629-2.042a40.106,40.106,0,0,0-2.98-3.625,14.137,14.137,0,0,1-1.942-3.324,11.4,11.4,0,0,0-1.591-2.774,10.845,10.845,0,0,0-1.235-.79C47.4,68.233,45.8,67.3,45.969,66.021a1.265,1.265,0,0,1,.768-1c1.26-.645,3.878-.262,5.205.481A28.709,28.709,0,0,1,54.476,67.1l1.867-2.91.69-4.654a.363.363,0,0,1,.078-.192c.039-.061.946-1.3,3.11-.52,1.566.568,1.458,2.273,1.391,3.294a3.938,3.938,0,0,0-.025.523c.985.414,5.514,2.418,5.915,3.822.415,1.444-1.522,7.687-2.059,9.147A35.406,35.406,0,0,0,64.3,81.172c.721,1.614,8.276,18.422,10.894,22.885,2.818,4.782,2.9,15.963,1.728,21.246-1.166,5.244-2.125,7.548-6.994,9.27a10.868,10.868,0,0,1-3.455.776m-18.038-69.7a3.016,3.016,0,0,0-1.266.214c-.239.122-.256.239-.261.284-.086.645,1.4,1.522,2.4,2.106a11.415,11.415,0,0,1,1.358.874,10.983,10.983,0,0,1,1.844,3.1,13.95,13.95,0,0,0,1.758,3.063,44.626,44.626,0,0,1,3.119,3.8.472.472,0,0,1,.067.147l.676,2.212c.047.314,2.359,22.606,2.643,28.126.629,12.747,1.614,20.887,2.687,22.323.184.248.353.478.506.7,1.238,1.742,1.758,2.44,5.645,1.091,4.462-1.583,5.261-3.5,6.4-8.58,1.152-5.205.985-16.133-1.619-20.57-2.774-4.707-10.674-22.348-11.011-23.1a.464.464,0,0,1-.031-.253,36.3,36.3,0,0,1,1.213-5.889c.837-2.3,2.3-7.617,2.034-8.563C66.35,65.9,62,63.765,61.1,63.473c-.529-.178-.49-.754-.445-1.413.078-1.107.07-2.036-.759-2.342-1.2-.437-1.775-.07-1.942.1l-.693,4.615a.379.379,0,0,1-.07.184l-2.187,3.425a.464.464,0,0,1-.314.214.435.435,0,0,1-.37-.083,27.328,27.328,0,0,0-2.84-1.842,6.943,6.943,0,0,0-3.049-.684m12.97-3.08.039.017a.056.056,0,0,1-.039-.017",
    transform: "translate(76.564 70.982)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276577",
    "data-name": "Path 276577",
    d: "M67.545,97.576c1.116-5.019,1.116-16.172-1.672-20.912-.3-.515-.673-1.2-1.088-1.995-6.307-1.833-12.3,1.16-12.3,1.16l-1.53.67c.2,2.329.356,4.279.415,5.464.278,5.575,1.116,20.353,2.788,22.584s1.953,3.622,6.693,1.95,5.575-3.9,6.691-8.922",
    transform: "translate(85.478 98.614)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276578",
    "data-name": "Path 276578",
    d: "M57.862,108.029c-1.614,0-2.326-.86-3.286-2.212-.156-.214-.317-.437-.492-.676C52.54,103.085,51.664,91.582,51.2,82.3c-.056-1.06-.192-2.843-.415-5.444a.485.485,0,0,1,.284-.476L52.6,75.7c.239-.117,6.2-3.057,12.616-1.177a.446.446,0,0,1,.292.231c.406.79.776,1.466,1.077,1.975,2.818,4.791,2.9,15.971,1.728,21.254-1.168,5.244-2.128,7.548-7,9.267a10.777,10.777,0,0,1-3.455.776m-6.1-30.913c.209,2.426.339,4.106.392,5.136.629,12.747,1.614,20.887,2.7,22.323.175.239.345.476.5.7,1.238,1.744,1.758,2.443,5.645,1.091,4.462-1.58,5.261-3.5,6.4-8.577,1.152-5.205.985-16.133-1.619-20.573-.292-.476-.629-1.1-1.013-1.833-5.953-1.627-11.7,1.166-11.751,1.182Zm16.088,20.77h0Z",
    transform: "translate(85.174 98.301)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276579",
    "data-name": "Path 276579",
    d: "M61.071,47.885a32.775,32.775,0,0,1,1.146,7.731c0,3.722-1.146,6.015.573,7.158s3.149,1.146,2.863,3.436a6.161,6.161,0,0,1-1.433,3.439s-.573,11.74-1.143,12.883-8.018-.287-9.737-.573-6.585,2.006-9.737-4.293-.573-15.752,5.155-20.617a140.09,140.09,0,0,1,12.313-9.164",
    transform: "translate(69.949 51.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276580",
    "data-name": "Path 276580",
    d: "M61.579,83.751a48.7,48.7,0,0,1-7.459-.921l-.559-.1a4.823,4.823,0,0,0-1.321.061c-2.281.275-6.129.659-8.76-4.607-3.18-6.36-.762-16.066,5.275-21.2a141.95,141.95,0,0,1,12.355-9.2.48.48,0,0,1,.723.267,33.277,33.277,0,0,1,1.157,7.865,27.578,27.578,0,0,1-.228,3.224c-.223,1.972-.292,2.949.59,3.533.392.262.768.459,1.113.645,1.191.629,2.22,1.174,1.959,3.255a6.875,6.875,0,0,1-1.436,3.564c-.114,2.312-.615,11.762-1.191,12.908-.206.423-.759.7-2.217.7m-8.31-1.989a2.8,2.8,0,0,1,.445.031l.568.1c6.913,1.221,8.41.96,8.685.707.331-.662.807-7.027,1.077-12.672a.49.49,0,0,1,.136-.314,5.662,5.662,0,0,0,1.308-3.155c.175-1.43-.339-1.7-1.469-2.3a13.246,13.246,0,0,1-1.191-.684c-1.4-.938-1.235-2.482-1.013-4.44a25.443,25.443,0,0,0,.223-3.116,31.308,31.308,0,0,0-.96-6.966,137.048,137.048,0,0,0-11.709,8.755c-5.728,4.868-8.04,14.052-5.047,20.041,2.359,4.7,5.667,4.309,7.809,4.092.423-.045.807-.083,1.138-.083",
    transform: "translate(69.648 51.642)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276581",
    "data-name": "Path 276581",
    d: "M48.875,52.533a.365.365,0,0,1-.175-.039.462.462,0,0,1-.261-.615,2.187,2.187,0,0,1,1.374-1.444,2.243,2.243,0,0,1,1.711.362.485.485,0,0,1,.1.668.492.492,0,0,1-.668.1,1.285,1.285,0,0,0-.69-.236.586.586,0,0,0-.2.031c-.3.083-.554.376-.754.874a.462.462,0,0,1-.437.3",
    transform: "translate(80.922 56.383)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276582",
    "data-name": "Path 276582",
    d: "M49.533,56.619a.47.47,0,0,1-.445-.306,7.287,7.287,0,0,1-.223-3.733.458.458,0,0,1,.559-.362.464.464,0,0,1,.362.562,6.556,6.556,0,0,0,.192,3.194.479.479,0,0,1-.275.615.467.467,0,0,1-.17.031",
    transform: "translate(81.485 59.631)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276583",
    "data-name": "Path 276583",
    d: "M51.229,58.978a2.378,2.378,0,0,1-1.082-.253,2.514,2.514,0,0,1-1.213-1.6.471.471,0,0,1,.314-.593.457.457,0,0,1,.59.314,1.624,1.624,0,0,0,.746,1.029,1.533,1.533,0,0,0,1.107.086.467.467,0,0,1,.6.306.473.473,0,0,1-.306.6,2.486,2.486,0,0,1-.754.108",
    transform: "translate(81.831 67.328)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276584",
    "data-name": "Path 276584",
    d: "M75.174,79.428s-1,4.357-1.8,6.657-16.024,6.529-22.631,7.406a113.1,113.1,0,0,1-13.128.865l.417,12.04s12.8.25,13.707.039,22.451-9.9,22.451-9.9L83.5,95.322s3.906-.94,4.056-3.984-3.3-11.654-4.866-13-4.885-4.9-6.869-2.71-.645,3.8-.645,3.8",
    transform: "translate(61.697 100.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276585",
    "data-name": "Path 276585",
    d: "M48.54,107.3c-3.617,0-8.794-.092-10.213-.122a.483.483,0,0,1-.47-.462l-.415-12.04a.511.511,0,0,1,.131-.345.489.489,0,0,1,.345-.147,113.991,113.991,0,0,0,13.07-.86c7.5-1,21.6-5.261,22.248-7.094.69-1.975,1.527-5.539,1.733-6.4-.337-.576-1-2.212.8-4.209.637-.693,1.772-1.321,3.692-.339A16.645,16.645,0,0,1,82.656,77.7c.239.214.453.415.645.576,1.7,1.458,5.191,10.243,5.03,13.384-.161,3.355-4.245,4.384-4.415,4.423L74.624,97.3c-2.5,1.121-21.555,9.684-22.476,9.9a32.984,32.984,0,0,1-3.608.1M38.8,106.229c4.938.109,12.516.192,13.139.047.746-.2,13.782-6.015,22.367-9.868a.247.247,0,0,1,.131-.039l9.309-1.213c-.017,0,3.516-.9,3.639-3.541.145-2.826-3.21-11.334-4.69-12.616-.2-.17-.423-.367-.67-.59a15.648,15.648,0,0,0-2.993-2.29c-1.483-.768-2.159-.275-2.548.131-1.683,1.867-.645,3.163-.631,3.171a.473.473,0,0,1,.092.415c-.039.178-1,4.407-1.811,6.7-.951,2.726-17.009,6.924-23.015,7.717a112.62,112.62,0,0,1-12.7.868Z",
    transform: "translate(61.393 99.848)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276586",
    "data-name": "Path 276586",
    d: "M46.827,89.066c0-5.211,1.335-5.344,2.829-7.4a115.31,115.31,0,0,1-11.843.707L37.5,93.414s7.008.645,11.275.929c-.326.568-1.95-1.936-1.95-5.277",
    transform: "translate(61.498 112.137)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276587",
    "data-name": "Path 276587",
    d: "M48.956,95.2a.606.606,0,0,1-.17-.022.842.842,0,0,1-.206-.083c-4.254-.3-10.75-.9-10.819-.9a.481.481,0,0,1-.431-.492l.314-11.042a.479.479,0,0,1,.479-.462A114.959,114.959,0,0,0,49.908,81.5a.468.468,0,0,1,.462.239.453.453,0,0,1-.022.515c-.323.445-.637.807-.929,1.143-1.052,1.191-1.806,2.042-1.806,5.981a8.434,8.434,0,0,0,1.33,4.793c.061,0,.114.006.175.006a.5.5,0,0,1,.392.256.48.48,0,0,1-.008.459.615.615,0,0,1-.545.314m.109-.929h0ZM38.3,93.291c1.413.122,5.937.529,9.453.79a10.411,10.411,0,0,1-1.091-4.707c0-4.293.9-5.314,2.042-6.61.053-.061.109-.131.17-.192-4.663.484-8.916.568-10.291.581Z",
    transform: "translate(61.191 111.826)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276588",
    "data-name": "Path 276588",
    d: "M115.943,149.324a44.633,44.633,0,0,0-18.7-12.466L80.548,143.98a38.009,38.009,0,0,0-5.122-8.9l-3.116-3.786,2-10.908s12.021-8.237,13.579-11.8c.017-.036.039-.075.056-.114,2.409,3.739,12.892,19.911,14.861,21.485,2.226,1.78,8.905,2,11.8-.668s4.229-4.451,3.561-8.46c0,0-4.451-9.573-6.9-13.8s-7.792-19.368-10.463-24.042c-1.917-3.352-2.69-5.672-4.042-7.292a26.584,26.584,0,0,0-3.305-4.507c-2.671-2.9-10.018-3.564-11.576-4.231s-1.78-.89-10.686-3.561S52.274,59.163,45.15,64.73c0,0-9.573,11.353-13.356,30.054s-4.006,37.621-4.451,40.962S23.111,155.336,22,164.684s8.683,18.7,14.692,21.6,31.834,3.338,46.974,0S122.845,167.8,122.845,167.8s.89-9.35-6.9-18.478",
    transform: "translate(33.714 75.267)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276589",
    "data-name": "Path 276589",
    d: "M58.153,189.378c-9.651,0-18.222-.86-21.363-2.373-5.62-2.71-16.133-12.263-14.959-22.075.723-6.076,2.551-14.981,3.895-21.485.721-3.519,1.291-6.307,1.449-7.464.1-.768.192-2.412.323-4.693.431-7.678,1.23-21.961,4.131-36.3C35.4,76.376,44.991,64.834,45.091,64.72,52.925,58.583,64,60.942,71.637,63.237c8.1,2.426,9.039,2.832,10.33,3.4l.406.175a17.717,17.717,0,0,0,2.312.576c2.941.623,7.386,1.561,9.423,3.764a26.411,26.411,0,0,1,3.372,4.6A18.813,18.813,0,0,1,99.666,79.5c.515,1.029,1.091,2.2,1.858,3.541,1.366,2.4,3.433,7.509,5.43,12.455,1.889,4.682,3.848,9.528,5.035,11.587,2.429,4.2,6.866,13.737,6.913,13.838a.3.3,0,0,1,.036.122c.737,4.407-.99,6.382-3.708,8.886-3.116,2.885-10.113,2.526-12.416.69-1.9-1.522-11.089-15.613-14.522-20.918-2.356,3.656-11.818,10.268-13.245,11.25l-1.928,10.5,2.979,3.617a37.462,37.462,0,0,1,5.008,8.569l16.255-6.924a.514.514,0,0,1,.323-.017,45.474,45.474,0,0,1,18.92,12.608c7.834,9.178,7.05,18.439,7.019,18.831a.48.48,0,0,1-.223.353c-.236.153-24.29,15.226-39.332,18.545-7.325,1.619-17.079,2.34-25.917,2.34M57.685,61.746A18.891,18.891,0,0,0,45.745,65.4,73.158,73.158,0,0,0,32.567,95.166c-2.893,14.283-3.692,28.521-4.123,36.174-.131,2.3-.223,3.964-.331,4.763-.153,1.2-.729,3.992-1.458,7.534-1.335,6.488-3.163,15.373-3.886,21.4-1.113,9.353,9.022,18.509,14.436,21.11,5.915,2.849,31.484,3.311,46.665-.031,14.138-3.124,36.438-16.817,38.817-18.3a26.939,26.939,0,0,0-6.8-17.894,44.507,44.507,0,0,0-18.314-12.263l-16.533,7.05a.5.5,0,0,1-.37,0,.491.491,0,0,1-.262-.262,37.493,37.493,0,0,0-5.044-8.777l-3.119-3.786a.5.5,0,0,1-.1-.384l2.006-10.911a.46.46,0,0,1,.2-.306c.122-.086,11.932-8.193,13.415-11.6a.59.59,0,0,1,.428-.339c.178-.006.378.017.462.156,6.159,9.551,13.27,20.178,14.758,21.377,2.02,1.614,8.432,1.906,11.172-.645,2.788-2.573,4.039-4.206,3.425-7.979-.376-.807-4.537-9.706-6.849-13.7A125.213,125.213,0,0,1,106.07,95.85a133.047,133.047,0,0,0-5.375-12.333c-.776-1.369-1.36-2.551-1.881-3.594A17.986,17.986,0,0,0,96.7,76.3a26.312,26.312,0,0,0-3.288-4.5c-1.833-1.984-6.1-2.882-8.93-3.48a16.755,16.755,0,0,1-2.479-.629l-.415-.178c-1.269-.551-2.181-.951-10.229-3.369a49.094,49.094,0,0,0-13.676-2.4m65.463,106.347h0Z",
    transform: "translate(33.411 74.973)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276590",
    "data-name": "Path 276590",
    d: "M43.819,78.792H43.8l-3.046-.1a.476.476,0,0,1,.014-.951h.017l3.049.1a.476.476,0,0,1-.017.951",
    transform: "translate(66.473 105.146)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276591",
    "data-name": "Path 276591",
    d: "M53.921,82.233H53.9l-7.84-.27a.476.476,0,0,1,.017-.951H46.1l5.636.192A85.547,85.547,0,0,0,41.3,76.958a.482.482,0,0,1-.306-.6.449.449,0,0,1,.6-.306,94.248,94.248,0,0,1,12.547,5.283.488.488,0,0,1,.239.545.479.479,0,0,1-.462.353",
    transform: "translate(67.691 102.097)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276592",
    "data-name": "Path 276592",
    d: "M56.128,78.221a10.373,10.373,0,0,1,1.58,4.568c0,2.109.353,4.921-.526,4.042s-1.23-3.867-1.23-3.867Z",
    transform: "translate(94.377 106.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276593",
    "data-name": "Path 276593",
    d: "M57.757,87.777a.886.886,0,0,1-.615-.306c-.96-.976-1.327-3.834-1.358-4.156l.17-4.813a.478.478,0,0,1,.353-.445.555.555,0,0,1,.52.206,10.682,10.682,0,0,1,1.658,4.824c0,.476.017.982.031,1.48.07,2.006.078,2.9-.506,3.158a.62.62,0,0,1-.253.053m-.921-7.456-.108,2.957a10.836,10.836,0,0,0,.86,3.2c.033-.515,0-1.3-.014-1.883-.022-.506-.039-1.027-.039-1.511a7.259,7.259,0,0,0-.7-2.765",
    transform: "translate(94.078 105.706)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276594",
    "data-name": "Path 276594",
    d: "M54.121,77.782s3.3-1.783,4.729.362,1.071,6.438,0,8.582-2.3.095-2.145-1.789-2.584-7.155-2.584-7.155",
    transform: "translate(91.113 103.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276595",
    "data-name": "Path 276595",
    d: "M58.181,88.423a.973.973,0,0,1-.284-.039c-.976-.275-1.466-1.864-1.36-3.177.117-1.43-1.789-5.469-2.534-6.9a.483.483,0,0,1,.2-.645c.147-.07,3.7-1.95,5.353.523,1.605,2.426,1.1,6.91.022,9.061-.476.96-1.013,1.174-1.4,1.174m-3.11-10.113c.69,1.383,2.557,5.275,2.418,6.972a2.494,2.494,0,0,0,.67,2.189h.014c.1,0,.314-.17.562-.654,1.052-2.1,1.3-6.187.022-8.107-.89-1.352-2.826-.762-3.686-.4",
    transform: "translate(90.805 103.677)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276596",
    "data-name": "Path 276596",
    d: "M53.679,76.961s3.3-1.783,4.729.362,1.071,6.438,0,8.582-2.3.095-2.145-1.789-2.584-7.155-2.584-7.155",
    transform: "translate(90.325 102.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276597",
    "data-name": "Path 276597",
    d: "M57.74,87.61a1.294,1.294,0,0,1-.284-.039c-.985-.275-1.474-1.864-1.369-3.185.117-1.427-1.78-5.461-2.526-6.888a.472.472,0,0,1,.2-.637c.147-.083,3.694-1.981,5.353.515,1.466,2.2,1.221,6.671.022,9.053-.476.96-1.013,1.182-1.4,1.182M54.63,77.5c.69,1.374,2.548,5.269,2.412,6.966-.092,1.152.376,2.112.668,2.187l.022.008c.1,0,.314-.17.562-.659,1.052-2.106,1.3-6.19.022-8.1-.89-1.346-2.826-.754-3.686-.4",
    transform: "translate(90.019 102.209)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276598",
    "data-name": "Path 276598",
    d: "M53.136,76.077s3.3-1.783,4.729.362,1.071,6.438,0,8.582-2.3.095-2.145-1.789-2.584-7.155-2.584-7.155",
    transform: "translate(89.357 100.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276599",
    "data-name": "Path 276599",
    d: "M57.2,86.72a.971.971,0,0,1-.284-.039c-.976-.275-1.466-1.864-1.36-3.177.117-1.43-1.789-5.469-2.534-6.9a.483.483,0,0,1,.2-.645c.147-.07,3.7-1.958,5.353.523,1.614,2.426,1.1,6.91.022,9.061-.476.96-1.013,1.174-1.4,1.174m-3.11-10.113c.69,1.383,2.557,5.275,2.418,6.972a2.494,2.494,0,0,0,.67,2.189h.014c.1,0,.314-.17.562-.654,1.052-2.1,1.3-6.187.022-8.107-.89-1.346-2.827-.754-3.686-.4",
    transform: "translate(89.05 100.635)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276600",
    "data-name": "Path 276600",
    d: "M86.8,51.293a18.8,18.8,0,0,1-2.551,9.74c-4.866,7.445-9.448,6.585-11.453,12.6s-4.868,12.313-1.716,15.749S76.8,90.814,76.8,90.814s2.006,5.152-3.149,10.307-14.03,3.149-16.322,2.29a15.459,15.459,0,0,1-4.009-2.29s-1.433,4.009-8.591,4.009-15.176-4.868-15.176-13.746S34.426,76.5,35.57,73.06s-2-14.032,2.865-20.617S50.748,40.989,56.474,40.989s16.851,3.124,16.9,3.149c.754.406,5.564-1.55,6.863-1.466,4.766.314,6.51,4.273,6.568,8.621",
    transform: "translate(47.342 39.657)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276601",
    "data-name": "Path 276601",
    d: "M45.045,105.906c-7.695,0-15.66-5.316-15.66-14.216,0-6.571,2.59-11.534,4.479-15.156a25.636,25.636,0,0,0,1.558-3.327,17.751,17.751,0,0,0,.145-5.275c-.228-4.624-.545-10.958,2.788-15.473C43.431,45.61,51,40.819,56.785,40.819c5.859,0,17.04,3.163,17.109,3.2a12.9,12.9,0,0,0,3.185-.746,15.953,15.953,0,0,1,3.38-.776h.106c4.387.292,6.944,3.6,7.019,9.092A19.376,19.376,0,0,1,84.958,61.6a23.659,23.659,0,0,1-6.68,6.78c-2.089,1.53-3.733,2.726-4.724,5.714-.267.79-.545,1.589-.821,2.387-1.819,5.2-3.539,10.115-1,12.886,2.818,3.057,5,1.458,5.083,1.374a.481.481,0,0,1,.423-.078.462.462,0,0,1,.314.287c.086.214,2.05,5.5-3.255,10.811-5.175,5.169-14.1,3.425-16.825,2.4a16.351,16.351,0,0,1-3.678-2.011c-.707,1.174-2.91,3.756-8.752,3.756M56.785,41.77c-5.5,0-12.764,4.629-17.663,11.259-3.133,4.237-2.824,10.38-2.6,14.859.122,2.448.223,4.39-.192,5.628a26.931,26.931,0,0,1-1.622,3.455c-1.842,3.539-4.368,8.377-4.368,14.72,0,8.3,7.478,13.262,14.706,13.262,6.7,0,8.084-3.539,8.137-3.692a.509.509,0,0,1,.323-.3.58.58,0,0,1,.431.092,15,15,0,0,0,3.878,2.22c2.573.968,11,2.64,15.81-2.189,3.978-3.978,3.533-7.879,3.194-9.27-1,.453-3.269.929-5.789-1.8C68.1,86.816,70,81.4,71.835,76.164c.275-.79.554-1.589.815-2.381,1.091-3.263,2.932-4.613,5.066-6.173a22.8,22.8,0,0,0,6.443-6.535,18.28,18.28,0,0,0,2.473-9.467c-.039-2.9-.89-7.809-6.129-8.157a14.422,14.422,0,0,0-3.155.737c-2.351.7-3.386.924-3.895.676-.022,0-11-3.094-16.67-3.094",
    transform: "translate(47.033 39.354)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276602",
    "data-name": "Path 276602",
    d: "M45.379,60.231a11.387,11.387,0,0,1-1.7-.122.476.476,0,0,1,.07-.946.206.206,0,0,1,.07.008,12.153,12.153,0,0,0,3,.022.42.42,0,0,1,.523.415.467.467,0,0,1-.414.523,11.728,11.728,0,0,1-1.552.1",
    transform: "translate(71.788 72.042)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276603",
    "data-name": "Path 276603",
    d: "M44.052,81.516a.455.455,0,0,1-.275-.092,6.526,6.526,0,0,1-2.8-4.638c-.245-2.281.7-4.677,2.743-6.935a85.113,85.113,0,0,1,6.763-6.543c3.272-2.9,6.09-5.419,8.747-9.581a19.517,19.517,0,0,0,2.7-7.011.461.461,0,0,1,.554-.384.473.473,0,0,1,.384.551,20.376,20.376,0,0,1-2.843,7.35c-2.718,4.276-5.728,6.958-8.908,9.79a82.482,82.482,0,0,0-6.7,6.474c-1.85,2.042-2.718,4.184-2.5,6.19a5.6,5.6,0,0,0,2.409,3.97.475.475,0,0,1-.275.86",
    transform: "translate(67.614 49.147)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276604",
    "data-name": "Path 276604",
    d: "M49.263,47.776a.474.474,0,0,1-.476-.476,16.794,16.794,0,0,0-.27-3.08.483.483,0,0,1,.37-.568c.039,0,.07-.008.1-.008a.481.481,0,0,1,.467.376,18.466,18.466,0,0,1,.284,3.28.472.472,0,0,1-.476.476",
    transform: "translate(81.11 44.389)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276605",
    "data-name": "Path 276605",
    d: "M40.658,77.166a.479.479,0,0,1-.476-.453c-.209-3.984,3.024-6.61,6.449-9.392A31.08,31.08,0,0,0,52.345,61.8c4-5.545,4.983-15.229,4.991-15.329a.477.477,0,0,1,.476-.428h.047a.486.486,0,0,1,.431.52c-.047.409-1.024,10.037-5.177,15.788a31.3,31.3,0,0,1-5.881,5.706c-3.372,2.743-6.282,5.108-6.1,8.61a.479.479,0,0,1-.453.5Z",
    transform: "translate(66.257 48.664)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276606",
    "data-name": "Path 276606",
    d: "M75.495,118.462S81.423,148.947,86.5,163.77s10.163,28.368,11.434,29.639,4.657,5.926,4.657,5.926a9.8,9.8,0,0,1-5.506,2.117c-2.963,0-6.774-3.809-10.163-5.926s-3.809-3.388-10.585-5.928-1.269-9.317.426-12.7a14.649,14.649,0,0,0,1.691-5.928,67.031,67.031,0,0,0-13.971-25.828c-10.585-11.857-12.7-39.379-12.7-39.379l20.322-7.623Z",
    transform: "translate(86.948 141.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276607",
    "data-name": "Path 276607",
    d: "M97.4,202.233c-2.226,0-4.813-1.928-7.308-3.8-1.038-.768-2.106-1.575-3.11-2.2-.968-.6-1.691-1.138-2.39-1.653a27.791,27.791,0,0,0-8.11-4.231,5.166,5.166,0,0,1-3.347-2.979c-.951-2.671.968-5.959,2.509-8.591.384-.662.746-1.269,1.007-1.792a14.285,14.285,0,0,0,1.636-5.711,67.673,67.673,0,0,0-13.846-25.516c-10.574-11.843-12.73-38.528-12.822-39.654a.47.47,0,0,1,.306-.484L72.241,98a.463.463,0,0,1,.406.031.49.49,0,0,1,.231.337l3.386,20.32c.114.576,6.006,30.685,11,45.235,5.575,16.263,10.235,28.374,11.317,29.45,1.277,1.291,4.562,5.8,4.7,5.99a.468.468,0,0,1-.078.637,10.154,10.154,0,0,1-5.806,2.234M52.6,106.377c.292,3.255,2.835,27.867,12.547,38.748a68.11,68.11,0,0,1,14.077,26.031,14.566,14.566,0,0,1-1.728,6.259c-.27.537-.632,1.16-1.029,1.836-1.366,2.342-3.241,5.545-2.443,7.8a4.248,4.248,0,0,0,2.8,2.4,28.534,28.534,0,0,1,8.332,4.362c.69.5,1.4,1.021,2.334,1.614,1.035.643,2.125,1.458,3.171,2.242,2.373,1.772,4.83,3.608,6.741,3.608a8.914,8.914,0,0,0,4.838-1.744c-.829-1.127-3.308-4.468-4.332-5.489-1.895-1.889-9.951-25.171-11.548-29.817-5.03-14.683-10.967-45.06-11.028-45.369v-.014L72.032,99.091Z",
    transform: "translate(86.644 141.188)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276608",
    "data-name": "Path 276608",
    d: "M83.426,141.443l-1.227.245s-7.2-9.737-12.7-13.125a12.08,12.08,0,0,0-6.351-2.114c-1.7,3.388-7.2,10.16-.423,12.7s7.2,3.811,10.585,5.928S80.5,151,83.47,151a9.8,9.8,0,0,0,5.5-2.117s-3.386-4.66-4.657-5.928a6.85,6.85,0,0,1-.89-1.516",
    transform: "translate(100.57 191.943)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276609",
    "data-name": "Path 276609",
    d: "M83.775,151.784c-2.226,0-4.813-1.925-7.311-3.8-1.035-.768-2.1-1.575-3.107-2.2-.968-.6-1.691-1.138-2.39-1.65a27.651,27.651,0,0,0-8.11-4.231,5.18,5.18,0,0,1-3.347-2.98c-.951-2.673.968-5.959,2.509-8.594.384-.659.746-1.266,1.007-1.789a.458.458,0,0,1,.462-.262,12.792,12.792,0,0,1,6.565,2.189c5.1,3.141,11.47,11.44,12.647,13.006l.938-.192a.456.456,0,0,1,.52.262,5.61,5.61,0,0,0,.793,1.374c1.283,1.3,4.568,5.806,4.707,6a.479.479,0,0,1-.078.645,10.233,10.233,0,0,1-5.806,2.226M63.734,127.236c-.245.467-.559,1-.89,1.566-1.369,2.342-3.241,5.545-2.443,7.8a4.241,4.241,0,0,0,2.8,2.4,28.676,28.676,0,0,1,8.332,4.362c.69.5,1.4,1.021,2.334,1.614,1.035.645,2.125,1.458,3.171,2.242,2.373,1.775,4.83,3.608,6.741,3.608a8.937,8.937,0,0,0,4.838-1.742c-.829-1.129-3.308-4.471-4.332-5.492a5.12,5.12,0,0,1-.812-1.313l-.876.178a.429.429,0,0,1-.476-.186c-.07-.1-7.2-9.706-12.563-13a12.076,12.076,0,0,0-5.82-2.042",
    transform: "translate(100.265 191.637)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276610",
    "data-name": "Path 276610",
    d: "M79.924,143.508c-3.352-2.315-6.371-7.45-11.821-10.655-4.955-2.913-7.5-3.018-8.607-2.8a4.609,4.609,0,0,0,3.1,2.8c6.78,2.543,7.2,3.811,10.585,5.928,2.184,1.366,4.543,3.427,6.741,4.727",
    transform: "translate(100.691 198.238)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276611",
    "data-name": "Path 276611",
    d: "M80.228,144.291a.5.5,0,0,1-.248-.07,43.221,43.221,0,0,1-3.625-2.521c-1.035-.782-2.112-1.58-3.124-2.212-.968-.606-1.689-1.143-2.387-1.658a27.831,27.831,0,0,0-8.11-4.231,5.111,5.111,0,0,1-3.388-3.1.512.512,0,0,1,.047-.392.5.5,0,0,1,.314-.223c1.452-.253,4.092.017,8.939,2.865a34.441,34.441,0,0,1,7.773,6.78,27.511,27.511,0,0,0,4.076,3.895.478.478,0,0,1-.267.868M60.484,130.76a4.639,4.639,0,0,0,2.587,1.95,28.494,28.494,0,0,1,8.332,4.362c.69.5,1.4,1.021,2.334,1.614.523.32,1.06.69,1.591,1.074a31.943,31.943,0,0,0-7.158-6.2c-3.948-2.309-6.282-2.8-7.556-2.8Z",
    transform: "translate(100.39 197.934)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276612",
    "data-name": "Path 276612",
    d: "M68.482,135.314a4.885,4.885,0,0,1-.643-.061,3.948,3.948,0,0,0,.643.061",
    transform: "translate(115.558 207.634)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276613",
    "data-name": "Path 276613",
    d: "M68.789,136.095a3.8,3.8,0,0,1-.729-.07.469.469,0,0,1-.384-.545.474.474,0,0,1,.467-.4.294.294,0,0,1,.07.006,3.873,3.873,0,0,0,.576.056.476.476,0,1,1,0,.951",
    transform: "translate(115.254 207.329)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276614",
    "data-name": "Path 276614",
    d: "M47.28,91.536s20.347-7.211,22.25-2.454,10.613,22.487,7.442,29.778S51.459,97.957,48.29,97.322s-1.385-3.65-1.01-5.786",
    transform: "translate(77.425 122.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276615",
    "data-name": "Path 276615",
    d: "M75.521,120.831c-4.131,0-12.424-8.516-19.146-15.412-3.425-3.508-6.963-7.15-7.879-7.325a2.714,2.714,0,0,1-1.895-1.16c-.637-1.043-.231-2.434.153-3.778.145-.5.284-.976.362-1.4a.46.46,0,0,1,.306-.362c2.128-.76,20.809-7.242,22.851-2.187.262.651.654,1.558,1.121,2.64,2.966,6.827,9.13,21.032,6.321,27.506A2.276,2.276,0,0,1,76,120.792a2.442,2.442,0,0,1-.476.039M48,92.2c-.083.4-.209.815-.331,1.221-.328,1.143-.676,2.334-.253,3.024a1.8,1.8,0,0,0,1.269.715c1.143.231,3.661,2.765,8.368,7.6,5.915,6.065,14.745,15.126,18.422,15.126a1.519,1.519,0,0,0,.345-.031,1.327,1.327,0,0,0,1.021-.89c2.651-6.09-3.4-20.033-6.318-26.738-.476-1.1-.868-2.011-1.138-2.674C68.171,86.446,55.738,89.492,48,92.2",
    transform: "translate(77.121 122.166)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276616",
    "data-name": "Path 276616",
    d: "M65.97,92.549s23.143-1.9,27.581,2.22-10.777,53.576-19.02,69.107c-12.889,24.29-9.014,30.635-9.014,30.635s.951,3.806,7.292,9.829,8.243,6.974,6.023,7.926-11.729,0-12.68-.634-7.926-6.34-14.266-8.243-5.389-3.171-2.537-8.877,2.537-.951,5.709-10.777a290.221,290.221,0,0,0,8.975-36.953c1.678-10.185,4.254-21.368,3.525-31.723L65.97,92.549",
    transform: "translate(78.679 130.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276617",
    "data-name": "Path 276617",
    d: "M75.375,213.445c-3.647,0-8.363-.562-9.178-1.107-.136-.1-.406-.292-.768-.568-2.195-1.644-8.015-6.012-13.376-7.625-3.071-.915-4.393-1.683-4.885-2.81-.606-1.413.262-3.158,1.714-6.037l.345-.69a10.915,10.915,0,0,1,2.412-3.55c.782-.759,1.4-1.358,3.272-7.164a289.41,289.41,0,0,0,8.961-36.881c.306-1.9.651-3.825,1-5.775,1.527-8.585,3.1-17.471,2.509-25.847L65.8,92.884a.48.48,0,0,1,.437-.506c.96-.064,23.4-1.875,27.945,2.348,4.952,4.6-11.05,54.836-18.923,69.68-12.516,23.575-9.061,30.109-9.03,30.171a.345.345,0,0,1,.056.131c.006.036,1.027,3.77,7.155,9.59,1.33,1.269,2.465,2.312,3.411,3.171,2.763,2.543,3.8,3.486,3.639,4.423-.1.59-.676.907-1.168,1.113a12.092,12.092,0,0,1-3.945.44M66.781,93.29l1.552,22.039c.6,8.493-.99,17.432-2.529,26.078-.345,1.942-.682,3.87-1,5.759a291.248,291.248,0,0,1-8.994,37.02c-1.95,6.037-2.64,6.7-3.516,7.556a10.266,10.266,0,0,0-2.226,3.294l-.345.693c-1.321,2.632-2.12,4.223-1.683,5.227.345.815,1.589,1.474,4.284,2.281,5.522,1.658,11.442,6.1,13.668,7.773.348.259.593.445.723.537.846.529,10.182,1.449,12.232.584.545-.231.593-.37.6-.4.07-.423-1.435-1.806-3.347-3.555-.946-.868-2.089-1.92-3.425-3.188-5.99-5.7-7.242-9.437-7.4-9.99-.406-.782-3.294-7.809,9.039-31.036,8.913-16.8,23.091-64.851,19.121-68.543-3.9-3.617-23.474-2.359-26.754-2.128",
    transform: "translate(78.375 130.447)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276618",
    "data-name": "Path 276618",
    d: "M127.882,114.91a30.773,30.773,0,0,0-11.937-14.194c-10.118-6.451-18.7-12.466-18.7-12.466l-16.7,7.125s4.076,6.9-16.848,10.394c-16.116,2.685-30.905-1.21-38.884-5.9-1.11,5.519-2.278,11.67-2.815,16.205-1.116,9.35,8.68,18.7,14.692,21.594s54.438,8.908,67.48.526c23.711-15.243,23.711-23.288,23.711-23.288",
    transform: "translate(33.716 123.875)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276619",
    "data-name": "Path 276619",
    d: "M78.879,143.276c-18.108,0-38.547-3.163-42.089-4.866-5.62-2.712-16.133-12.266-14.959-22.078.568-4.754,1.806-11.181,2.818-16.25a.483.483,0,0,1,.278-.345.493.493,0,0,1,.428.031c7.511,4.4,22.122,8.569,38.572,5.837,11.718-1.95,15.4-4.93,16.425-7.08a2.9,2.9,0,0,0,.083-2.612.524.524,0,0,1-.036-.389.483.483,0,0,1,.267-.287L97.362,88.12a.475.475,0,0,1,.462.045c.083.061,8.691,6.081,18.673,12.455a30.967,30.967,0,0,1,12.135,14.444.362.362,0,0,1,.031.156c0,.337-.27,8.477-23.936,23.68-5.044,3.249-15.037,4.376-25.847,4.376M25.456,100.92c-.982,4.938-2.142,11-2.687,15.518-1.113,9.353,9.022,18.509,14.436,21.11,5.483,2.651,54.115,8.838,67.015.554C126.1,124.033,127.6,116.124,127.7,115.286a30.777,30.777,0,0,0-11.712-13.868c-9.13-5.82-17.1-11.348-18.5-12.324L81.474,95.929a4.078,4.078,0,0,1-.245,2.963c-1.107,2.373-4.977,5.622-17.148,7.648-16.286,2.712-30.824-1.249-38.625-5.62",
    transform: "translate(33.411 123.571)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276620",
    "data-name": "Path 276620",
    d: "M77.34,93.162c-2.231,1.828-6.6,3.767-14.956,5.161-16.116,2.685-30.905-1.21-38.884-5.9-.284,1.413-.573,2.868-.851,4.329,5.464,3.286,16.951,8.863,29.906,7.272,15.454-1.9,22.325-6.115,24.785-10.866",
    transform: "translate(35.03 131.32)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276621",
    "data-name": "Path 276621",
    d: "M48.232,105.084c-11.042,0-20.517-4.607-25.525-7.617a.476.476,0,0,1-.223-.5c.284-1.458.568-2.916.854-4.329a.479.479,0,0,1,.275-.348.5.5,0,0,1,.431.033c7.509,4.4,22.122,8.569,38.57,5.834,7.127-1.191,12.088-2.893,14.736-5.06a.478.478,0,0,1,.723.593c-2.949,5.689-11.412,9.428-25.149,11.111a37.521,37.521,0,0,1-4.693.284M23.483,96.822c5.689,3.372,16.831,8.532,29.319,7.041,11.74-1.444,19.5-4.362,23.127-8.685-2.963,1.636-7.369,2.949-13.162,3.917-16.286,2.71-30.822-1.252-38.625-5.628-.223,1.1-.437,2.226-.659,3.355",
    transform: "translate(34.721 131.016)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276622",
    "data-name": "Path 276622",
    d: "M37.351,103.664a.5.5,0,0,1-.306-.108.488.488,0,0,1-.064-.676c.782-.935,1.541-1.889,2.29-2.854a.467.467,0,0,1,.665-.086.478.478,0,0,1,.089.668c-.748.968-1.525,1.936-2.306,2.888a.5.5,0,0,1-.367.17",
    transform: "translate(60.38 144.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276623",
    "data-name": "Path 276623",
    d: "M38.848,109.843a.455.455,0,0,1-.275-.092.471.471,0,0,1-.108-.662A146.82,146.82,0,0,0,48.209,93.6a.49.49,0,0,1,.645-.2.48.48,0,0,1,.2.645,146.291,146.291,0,0,1-9.82,15.6.471.471,0,0,1-.384.2",
    transform: "translate(63.051 132.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276624",
    "data-name": "Path 276624",
    d: "M35.641,108.513a.476.476,0,0,1-.284-.86c5.9-4.345,11.573-11.871,11.626-11.949a.494.494,0,0,1,.668-.1.48.48,0,0,1,.1.668c-.061.078-5.82,7.717-11.826,12.149a.48.48,0,0,1-.284.092",
    transform: "translate(57.336 136.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276625",
    "data-name": "Path 276625",
    d: "M72.807,141.752c-6.34-6.023-7.292-9.829-7.292-9.829a2.036,2.036,0,0,1-.5-.709c-.428.453-1.719,1.3-4.888.078-2.749-1.057-5.355-2.815-8.1-4.059-.654,1.166-1.291,1.92-2.676,4.69-2.854,5.709-3.806,6.974,2.534,8.877S65.2,148.41,66.15,149.044s10.46,1.586,12.68.634.317-1.9-6.023-7.926",
    transform: "translate(78.678 193.342)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276626",
    "data-name": "Path 276626",
    d: "M75.372,150.857c-3.647,0-8.36-.559-9.175-1.1-.139-.1-.406-.292-.768-.57-2.195-1.641-8.018-6.012-13.376-7.625-3.071-.913-4.393-1.68-4.885-2.81-.606-1.413.262-3.155,1.714-6.034l.345-.693a38.03,38.03,0,0,1,2.05-3.661c.231-.362.428-.684.637-1.054a.464.464,0,0,1,.615-.2c1.2.545,2.387,1.188,3.539,1.819a38.788,38.788,0,0,0,4.532,2.226c2.924,1.138,4.031.409,4.376.039a.379.379,0,0,1,.423-.139.489.489,0,0,1,.353.262,1.751,1.751,0,0,0,.362.545.537.537,0,0,1,.167.261c.008.039,1.029,3.77,7.158,9.592,1.327,1.266,2.465,2.309,3.408,3.172,2.765,2.54,3.8,3.486,3.642,4.421-.1.593-.676.907-1.168,1.116a12.117,12.117,0,0,1-3.948.437M52.521,128.151c-.139.239-.284.467-.437.715a38.515,38.515,0,0,0-2.014,3.586l-.345.69c-1.319,2.635-2.12,4.223-1.68,5.23.345.812,1.589,1.474,4.284,2.281,5.522,1.658,11.442,6.1,13.668,7.77.345.261.593.445.723.537.843.531,10.182,1.452,12.232.584.545-.231.59-.367.6-.4.07-.423-1.435-1.805-3.347-3.555-.946-.868-2.089-1.922-3.425-3.188-5.762-5.475-7.144-9.144-7.381-9.907a2.419,2.419,0,0,1-.209-.262c-.79.5-2.273.823-4.93-.192a40.793,40.793,0,0,1-4.646-2.278c-1.013-.554-2.05-1.121-3.094-1.614",
    transform: "translate(78.375 193.034)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276627",
    "data-name": "Path 276627",
    d: "M58.774,104.036a.489.489,0,0,1-.406-.223.479.479,0,0,1,.153-.659l10.78-6.66a.494.494,0,0,1,.662.156.481.481,0,0,1-.156.659l-10.78,6.657a.512.512,0,0,1-.253.07",
    transform: "translate(98.553 138.447)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276628",
    "data-name": "Path 276628",
    d: "M12.155,78.251s34.358-4.3,56.3,1.908l3.341,83.5H20.267s3.338-44.854-8.112-85.413",
    transform: "translate(16.33 103.476)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276629",
    "data-name": "Path 276629",
    d: "M72.11,164.437H20.577a.449.449,0,0,1-.345-.153.458.458,0,0,1-.131-.362c.036-.445,3.2-45.235-8.1-85.243a.464.464,0,0,1,.061-.392.459.459,0,0,1,.337-.206c.345-.064,34.694-4.248,56.5,1.92a.482.482,0,0,1,.345.445l3.341,83.5a.471.471,0,0,1-.476.49m-51.027-.951H71.618L68.308,80.83c-20.1-5.561-50.763-2.373-55.242-1.875,10.53,37.727,8.332,79.454,8.018,84.531",
    transform: "translate(16.02 103.178)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276630",
    "data-name": "Path 276630",
    d: "M68.46,80.159c-21.95-6.2-56.3-1.908-56.3-1.908a231.157,231.157,0,0,1,7.3,41.3A205.925,205.925,0,0,1,71.517,156.6Z",
    transform: "translate(16.33 103.476)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276631",
    "data-name": "Path 276631",
    d: "M71.827,157.374a.435.435,0,0,1-.328-.139,204.41,204.41,0,0,0-51.951-36.967.467.467,0,0,1-.262-.376A228.952,228.952,0,0,0,12,78.679a.463.463,0,0,1,.061-.392.471.471,0,0,1,.337-.209c.345-.061,34.694-4.245,56.5,1.922a.475.475,0,0,1,.345.445L72.3,156.881a.489.489,0,0,1-.281.453.6.6,0,0,1-.195.039M20.215,119.538a205.136,205.136,0,0,1,51.091,36.183l-3-74.891C48.2,75.269,17.542,78.457,13.066,78.955a231.4,231.4,0,0,1,7.15,40.584",
    transform: "translate(16.02 103.178)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276632",
    "data-name": "Path 276632",
    d: "M62.987,186.842A1.9,1.9,0,0,1,61.2,185.6c-7.628-20.5-9.551-73.726-9.628-75.982a1.9,1.9,0,0,1,3.8-.134c.017.548,1.978,54.866,9.392,74.791a1.9,1.9,0,0,1-1.783,2.565",
    transform: "translate(86.575 158.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276633",
    "data-name": "Path 276633",
    d: "M63.292,187.62a2.345,2.345,0,0,1-2.226-1.552c-7.695-20.656-9.584-73.87-9.662-76.129a2.358,2.358,0,0,1,2.3-2.456h.092a2.383,2.383,0,0,1,2.365,2.3c.014.537,1.967,54.752,9.361,74.632a2.375,2.375,0,0,1-2.228,3.21m-9.506-79.187h-.053a1.388,1.388,0,0,0-.99.445,1.4,1.4,0,0,0-.384,1.029c.075,2.251,1.956,55.311,9.6,75.829a1.463,1.463,0,0,0,1.836.846,1.437,1.437,0,0,0,.8-.746,1.413,1.413,0,0,0,.036-1.091c-7.447-20.019-9.406-74.4-9.42-74.938a1.452,1.452,0,0,0-.453-.99,1.394,1.394,0,0,0-.968-.384",
    transform: "translate(86.27 158.146)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276634",
    "data-name": "Path 276634",
    d: "M48.1,186.842a1.9,1.9,0,0,1-1.783-1.241c-7.628-20.5-9.551-73.726-9.628-75.982a1.9,1.9,0,0,1,3.8-.134c.017.548,1.978,54.866,9.392,74.791a1.9,1.9,0,0,1-1.783,2.565",
    transform: "translate(60.048 158.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276635",
    "data-name": "Path 276635",
    d: "M48.406,187.621a2.345,2.345,0,0,1-2.226-1.552c-7.695-20.656-9.584-73.87-9.662-76.129a2.358,2.358,0,0,1,2.3-2.456,2.444,2.444,0,0,1,1.7.637,2.347,2.347,0,0,1,.759,1.658c.014.537,1.967,54.752,9.361,74.632a2.375,2.375,0,0,1-2.228,3.21M38.9,108.434h-.053a1.388,1.388,0,0,0-.99.445,1.4,1.4,0,0,0-.384,1.029c.075,2.251,1.956,55.312,9.6,75.829a1.459,1.459,0,0,0,1.836.846,1.437,1.437,0,0,0,.8-.746,1.413,1.413,0,0,0,.036-1.091c-7.447-20.019-9.406-74.4-9.42-74.938a1.452,1.452,0,0,0-.453-.99,1.394,1.394,0,0,0-.968-.384",
    transform: "translate(59.743 158.146)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276636",
    "data-name": "Path 276636",
    d: "M128.085,110.432H14.755v-3.778H124.3a3.78,3.78,0,0,1,3.781,3.778",
    transform: "translate(20.963 156.671)",
    fill: "#fda93d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276637",
    "data-name": "Path 276637",
    d: "M128.391,111.211H15.059a.477.477,0,0,1-.476-.476v-3.778a.477.477,0,0,1,.476-.476H124.613a4.262,4.262,0,0,1,4.254,4.254.477.477,0,0,1-.476.476M15.534,110.26H127.885a3.311,3.311,0,0,0-3.272-2.826H15.534Z",
    transform: "translate(20.656 156.364)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25548",
    "data-name": "Rectangle 25548",
    width: 113.33,
    height: 3.778,
    transform: "translate(35.715 266.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276638",
    "data-name": "Path 276638",
    d: "M128.391,112.238H15.059a.477.477,0,0,1-.476-.476v-3.778a.477.477,0,0,1,.476-.476H128.391a.477.477,0,0,1,.476.476v3.778a.477.477,0,0,1-.476.476m-112.857-.951H127.916V108.46H15.534Z",
    transform: "translate(20.656 158.194)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276639",
    "data-name": "Path 276639",
    d: "M33.309,240.882a1.928,1.928,0,0,1-.4-.042,1.9,1.9,0,0,1-1.469-2.253c10.752-50.955.918-158.106.818-159.183a1.9,1.9,0,0,1,3.789-.353c.1,1.082,9.987,108.8-.885,160.323a1.9,1.9,0,0,1-1.858,1.508",
    transform: "translate(50.632 104.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276640",
    "data-name": "Path 276640",
    d: "M33.612,241.669a1.907,1.907,0,0,1-.5-.053,2.383,2.383,0,0,1-1.828-2.818c10.7-50.666.907-157.956.807-159.032a2.408,2.408,0,0,1,2.15-2.6,2.247,2.247,0,0,1,1.736.54,2.381,2.381,0,0,1,.86,1.611c.1,1.091,9.946,109.073-.89,160.468a2.4,2.4,0,0,1-2.334,1.881m.86-163.553a.776.776,0,0,0-.139.008,1.43,1.43,0,0,0-1.288,1.558c.1,1.077,9.9,108.512-.823,159.316a1.427,1.427,0,0,0,1.1,1.689,1.094,1.094,0,0,0,.292.031,1.434,1.434,0,0,0,1.4-1.129c10.814-51.247.976-159.091.876-160.176a1.371,1.371,0,0,0-.515-.965,1.4,1.4,0,0,0-.9-.331",
    transform: "translate(50.327 104.094)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276641",
    "data-name": "Path 276641",
    d: "M12.113,240.68a1.859,1.859,0,0,1-.517-.072,1.9,1.9,0,0,1-1.313-2.348C35.028,150.479,14.019,79.8,13.8,79.1a1.9,1.9,0,0,1,3.639-1.113c.22.712,21.566,72.4-3.5,161.308a1.906,1.906,0,0,1-1.831,1.385",
    transform: "translate(12.864 103.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276642",
    "data-name": "Path 276642",
    d: "M12.422,241.465a2.1,2.1,0,0,1-.659-.1,2.381,2.381,0,0,1-1.636-2.932C34.8,150.945,13.874,80.246,13.66,79.539a2.408,2.408,0,0,1,.167-1.814,2.377,2.377,0,0,1,1.408-1.152,2.3,2.3,0,0,1,1.8.178,2.326,2.326,0,0,1,1.16,1.4c.223.707,21.8,71.875-3.486,161.581a2.4,2.4,0,0,1-2.29,1.736m3.5-164.046a1.527,1.527,0,0,0-.415.061,1.43,1.43,0,0,0-.946,1.78c.217.707,21.227,71.678-3.516,159.433a1.425,1.425,0,0,0,2.743.773c25.216-89.427,3.722-160.334,3.5-161.041a1.41,1.41,0,0,0-.7-.837,1.347,1.347,0,0,0-.668-.17",
    transform: "translate(12.558 102.88)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276643",
    "data-name": "Path 276643",
    d: "M130.894,200.348h-.022a.957.957,0,0,1-.929-.976c.022-.951,2.181-95.87,3.024-110.437.292-4.938,1.814-8.2,4.51-9.676,4.092-2.267,9.245.545,9.467.676a.943.943,0,0,1,.367,1.288.933.933,0,0,1-1.288.37c-.047-.022-4.5-2.42-7.634-.668-2.089,1.152-3.272,3.884-3.516,8.115-.854,14.536-3,109.418-3.027,110.378a.956.956,0,0,1-.952.929",
    transform: "translate(226.225 106.284)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276644",
    "data-name": "Path 276644",
    d: "M135.006,192.028h-.047a.961.961,0,0,1-.9-1c4.254-85.137-5.03-107.168-5.122-107.382a.943.943,0,0,1,.484-1.252.96.96,0,0,1,1.249.476c.392.876,9.576,22.415,5.291,108.25a.959.959,0,0,1-.951.907",
    transform: "translate(224.277 113.308)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276645",
    "data-name": "Path 276645",
    d: "M154.413,88.717s-4.471,2.865-7.016-.415,1.722-9.286-2.039-11.854S135.109,77.8,135.109,77.8s5,1.466,4.838,4.2-2.571,3.761-2.89,2.568-2.7-7.2-6.763-4.7a10.055,10.055,0,0,0-4.679,6.374s9.448-1.007,10.021,2.548-3.875-.62-7.773-.851-7.453.342-7.2,2.7a30.831,30.831,0,0,1-.37,6.237,11.6,11.6,0,0,1,7.592-2.682c4.287.253,4.126,2.982.228,2.751s-7.247,3.486-7.247,3.486,3.553,6.076,8.071,9.08,6.145,1.928,6.671-.389-.684-8.254,2.042-8.093-4.518,10.293-1.032,10.891,6.282-.412,7.2-2.7l.918-2.292s-1.216-5.94-.687-8.257,1.168.07,1.789,2.846,1.007,9.445,2.2,9.125,5-5.18,5.895-7.083-5.021-7.728-4.952-8.9,4.632,1.057,5.344,2.273a30.45,30.45,0,0,1,1.4,2.821s2.843-1.789,2.776-7.269-4.081-3.761-4.081-3.761",
    transform: "translate(209.029 101.291)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87905",
    "data-name": "Group 87905",
    transform: "translate(329.324 176.868)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87904",
    "data-name": "Group 87904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87903",
    "data-name": "Group 87903",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276646",
    "data-name": "Path 276646",
    d: "M154.413,88.717s-4.471,2.865-7.016-.415,1.722-9.286-2.039-11.854S135.109,77.8,135.109,77.8s5,1.466,4.838,4.2-2.571,3.761-2.89,2.568-2.7-7.2-6.763-4.7a10.055,10.055,0,0,0-4.679,6.374s9.448-1.007,10.021,2.548-3.875-.62-7.773-.851-7.453.342-7.2,2.7a30.831,30.831,0,0,1-.37,6.237,11.6,11.6,0,0,1,7.592-2.682c4.287.253,4.126,2.982.228,2.751s-7.247,3.486-7.247,3.486,3.553,6.076,8.071,9.08,6.145,1.928,6.671-.389-.684-8.254,2.042-8.093-4.518,10.293-1.032,10.891,6.282-.412,7.2-2.7l.918-2.292s-1.216-5.94-.687-8.257,1.168.07,1.789,2.846,1.007,9.445,2.2,9.125,5-5.18,5.895-7.083-5.021-7.728-4.952-8.9,4.632,1.057,5.344,2.273a30.45,30.45,0,0,1,1.4,2.821s2.843-1.789,2.776-7.269-4.081-3.761-4.081-3.761",
    transform: "translate(-120.295 -75.577)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276647",
    "data-name": "Path 276647",
    d: "M124.713,92.627a.492.492,0,0,1-.3-.108.468.468,0,0,1-.067-.668c2.971-3.678,7.278-8.555,10.925-10.911a.475.475,0,0,1,.662.139.481.481,0,0,1-.139.659c-3.547,2.29-7.778,7.088-10.713,10.713a.471.471,0,0,1-.367.175",
    transform: "translate(216.056 110.707)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276648",
    "data-name": "Path 276648",
    d: "M123.5,88.939a.455.455,0,0,1-.275-.092.471.471,0,0,1-.108-.662s.751-1.043,1.972-2.61a.477.477,0,0,1,.754.584c-1.2,1.55-1.959,2.579-1.959,2.579a.471.471,0,0,1-.384.2",
    transform: "translate(213.894 118.782)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276649",
    "data-name": "Path 276649",
    d: "M134.416,94.561a.469.469,0,0,1-.467-.415c-.776-6.112-5.008-12.149-5.055-12.21a.48.48,0,0,1,.785-.554c.175.256,4.407,6.29,5.205,12.641a.462.462,0,0,1-.406.529.155.155,0,0,1-.061.008",
    transform: "translate(224.208 111.285)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276650",
    "data-name": "Path 276650",
    d: "M128.277,90.531h-.031a.48.48,0,0,1-.445-.506c.306-5.138-.139-6.329-.292-6.582a.5.5,0,0,1-.4-.236.481.481,0,0,1,.178-.654.736.736,0,0,1,.69.031c.323.2,1.177.721.776,7.5a.471.471,0,0,1-.476.445",
    transform: "translate(221.063 113.595)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276651",
    "data-name": "Path 276651",
    d: "M128.659,85.048a.459.459,0,0,1-.353-.161.467.467,0,0,1,.039-.668c.083-.083,2.22-2.081,1.029-6.09a.474.474,0,0,1,.314-.593.469.469,0,0,1,.59.317c1.383,4.615-1.188,6.972-1.3,7.072a.458.458,0,0,1-.314.122",
    transform: "translate(223.091 104.749)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276652",
    "data-name": "Path 276652",
    d: "M128.587,84.233a.473.473,0,0,1-.415-.245l-1.767-3.233a.471.471,0,0,1,.184-.645.484.484,0,0,1,.645.184L129,83.526a.468.468,0,0,1-.184.645.511.511,0,0,1-.231.061",
    transform: "translate(219.815 109.273)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276653",
    "data-name": "Path 276653",
    d: "M131.964,86.2a.438.438,0,0,1-.284-.1c-.053-.039-5.544-4.154-8.869-4.345a.48.48,0,0,1-.445-.506.471.471,0,0,1,.476-.445h.031c3.608.214,9.144,4.368,9.375,4.546a.46.46,0,0,1,.092.659.471.471,0,0,1-.376.192",
    transform: "translate(212.722 110.606)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276654",
    "data-name": "Path 276654",
    d: "M154.5,77.963s-.178,6.429-5.2,6.744-8.123-8.054-13.259-6.04-5.634,11.184-5.634,11.184,4.877-4.006,7.5-1.984,2.011,5.136.6,4.643-9.053-2.2-9.317,3.567a12.165,12.165,0,0,0,3.191,9.028s5.43-10.143,9.381-8.3-3.263,3.458-6.151,7.205-4.735,7.695-2.2,9.053a37.284,37.284,0,0,1,6,4.618,14.064,14.064,0,0,1,2.487-9.428c3.177-4.12,5.8-2.1,2.913,1.647s-1.452,9.631-1.452,9.631,8.507.584,14.594-1.889,6.118-4.841,4.159-6.947-8.733-4.938-6.713-7.561,7.228,11.542,10.2,8.46,3.873-6.571,2.2-9.053l-1.669-2.482s-6.774-2.832-8.733-4.941.865-1.124,4.065.147,10.146,5.433,10.638,4.02-1.78-8.538-3.077-10.73-11.159-.242-12.282-1.107,4.215-3.917,5.914-3.8a36.593,36.593,0,0,1,3.778.523s.147-4.067-5.386-7.734-6.546,1.522-6.546,1.522",
    transform: "translate(224.876 100.495)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87908",
    "data-name": "Group 87908",
    transform: "translate(354.061 175.623)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87907",
    "data-name": "Group 87907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87906",
    "data-name": "Group 87906",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276655",
    "data-name": "Path 276655",
    d: "M154.5,77.963s-.178,6.429-5.2,6.744-8.123-8.054-13.259-6.04-5.634,11.184-5.634,11.184,4.877-4.006,7.5-1.984,2.011,5.136.6,4.643-9.053-2.2-9.317,3.567a12.165,12.165,0,0,0,3.191,9.028s5.43-10.143,9.381-8.3-3.263,3.458-6.151,7.205-4.735,7.695-2.2,9.053a37.284,37.284,0,0,1,6,4.618,14.064,14.064,0,0,1,2.487-9.428c3.177-4.12,5.8-2.1,2.913,1.647s-1.452,9.631-1.452,9.631,8.507.584,14.594-1.889,6.118-4.841,4.159-6.947-8.733-4.938-6.713-7.561,7.228,11.542,10.2,8.46,3.873-6.571,2.2-9.053l-1.669-2.482s-6.774-2.832-8.733-4.941.865-1.124,4.065.147,10.146,5.433,10.638,4.02-1.78-8.538-3.077-10.73-11.159-.242-12.282-1.107,4.215-3.917,5.914-3.8a36.593,36.593,0,0,1,3.778.523s.147-4.067-5.386-7.734-6.546,1.522-6.546,1.522",
    transform: "translate(-129.186 -75.128)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276656",
    "data-name": "Path 276656",
    d: "M139.871,99.894a.467.467,0,0,1-.453-.337c-1.65-5.483-3.594-13.117-3.469-18.347a.474.474,0,0,1,.476-.467h.006a.474.474,0,0,1,.47.484c-.122,5.1,1.8,12.639,3.425,18.052a.473.473,0,0,1-.314.593.484.484,0,0,1-.139.022",
    transform: "translate(236.919 110.498)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276657",
    "data-name": "Path 276657",
    d: "M139.217,92.923a.478.478,0,0,1-.445-.314s-.537-1.466-1.269-3.756a.481.481,0,0,1,.309-.6.474.474,0,0,1,.6.306c.723,2.265,1.252,3.717,1.252,3.725a.47.47,0,0,1-.284.606.415.415,0,0,1-.161.031",
    transform: "translate(239.662 123.843)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276658",
    "data-name": "Path 276658",
    d: "M153.157,84.561a.444.444,0,0,1-.214-.053c-6.212-3.166-14.413-3.28-15.582-3.28h-.153a.476.476,0,0,1-.008-.951c.376.022,9.278-.131,16.172,3.386a.475.475,0,0,1-.214.9",
    transform: "translate(238.324 109.667)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276659",
    "data-name": "Path 276659",
    d: "M144.919,88.1a.465.465,0,0,1-.292-.1c-5.1-3.931-6.571-4.215-6.894-4.215h-.017a.453.453,0,0,1-.406.236h-.031a.482.482,0,0,1-.445-.506.739.739,0,0,1,.437-.593c.645-.236,2.164-.136,7.94,4.323a.481.481,0,0,1,.086.67.468.468,0,0,1-.378.184m-7.133-4.523v0Z",
    transform: "translate(238.506 114.253)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276660",
    "data-name": "Path 276660",
    d: "M139.185,84.591a.469.469,0,0,1-.467-.415c-.025-.145-.57-3.717-5.469-5.269a.477.477,0,0,1-.306-.6.49.49,0,0,1,.6-.306c5.5,1.742,6.09,5.873,6.112,6.051a.462.462,0,0,1-.406.529.155.155,0,0,1-.061.008",
    transform: "translate(231.532 105.582)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276661",
    "data-name": "Path 276661",
    d: "M138.838,83.365h-.047l-4.437-.437a.478.478,0,0,1,.047-.954h.045l4.44.44a.486.486,0,0,1,.428.52.481.481,0,0,1-.476.431",
    transform: "translate(233.314 112.691)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276662",
    "data-name": "Path 276662",
    d: "M132.435,91.331a.46.46,0,0,1-.292-.1.477.477,0,0,1-.083-.668c2.648-3.441,10.558-6.151,10.9-6.265a.5.5,0,0,1,.606.3.483.483,0,0,1-.3.606c-.078.025-7.97,2.726-10.452,5.945a.462.462,0,0,1-.376.184",
    transform: "translate(229.82 116.797)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276663",
    "data-name": "Path 276663",
    d: "M144.641,175.356h-.008a.958.958,0,0,1-.943-.96c.423-63.975-24.434-81.3-24.687-81.465a.95.95,0,0,1,1.052-1.583c1.06.7,25.97,17.916,25.539,83.062a.953.953,0,0,1-.951.946",
    transform: "translate(205.981 129.112)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276664",
    "data-name": "Path 276664",
    d: "M150.124,91.843s-.812,7.4-6.632,7.289-8.616-10.057-14.731-8.218-7.556,12.371-7.556,12.371,6.006-4.159,8.841-1.58,1.839,6.115.256,5.414-10.24-3.391-11.089,3.238a14.089,14.089,0,0,0,2.832,10.719s7.222-11.195,11.606-8.688-4.092,3.681-7.776,7.731-6.193,8.432-3.394,10.238a43.221,43.221,0,0,1,6.479,5.9s-.292-6.19,3.761-10.644,6.891-1.875,3.2,2.176-2.584,10.975-2.584,10.975,9.762,1.477,17.017-.8,7.517-5,5.455-7.623-9.612-6.524-7.03-9.359,7.25,14,10.969,10.725,5.088-7.216,3.394-10.238l-1.691-3.021s-7.55-3.909-9.612-6.524,1.1-1.216,4.677.554,11.195,7.225,11.9,5.642-1.249-10.021-2.537-12.672-12.853-1.333-14.069-2.437,5.233-4.123,7.186-3.828a42.418,42.418,0,0,1,4.309.96s.554-4.677-5.486-9.431-7.7,1.138-7.7,1.138",
    transform: "translate(206.88 124.947)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87911",
    "data-name": "Group 87911",
    transform: "translate(325.966 213.798)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87910",
    "data-name": "Group 87910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87909",
    "data-name": "Group 87909",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276665",
    "data-name": "Path 276665",
    d: "M150.124,91.843s-.812,7.4-6.632,7.289-8.616-10.057-14.731-8.218-7.556,12.371-7.556,12.371,6.006-4.159,8.841-1.58,1.839,6.115.256,5.414-10.24-3.391-11.089,3.238a14.089,14.089,0,0,0,2.832,10.719s7.222-11.195,11.606-8.688-4.092,3.681-7.776,7.731-6.193,8.432-3.394,10.238a43.221,43.221,0,0,1,6.479,5.9s-.292-6.19,3.761-10.644,6.891-1.875,3.2,2.176-2.584,10.975-2.584,10.975,9.762,1.477,17.017-.8,7.517-5,5.455-7.623-9.612-6.524-7.03-9.359,7.25,14,10.969,10.725,5.088-7.216,3.394-10.238l-1.691-3.021s-7.55-3.909-9.612-6.524,1.1-1.216,4.677.554,11.195,7.225,11.9,5.642-1.249-10.021-2.537-12.672-12.853-1.333-14.069-2.437,5.233-4.123,7.186-3.828a42.418,42.418,0,0,1,4.309.96s.554-4.677-5.486-9.431-7.7,1.138-7.7,1.138",
    transform: "translate(-119.086 -88.851)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276666",
    "data-name": "Path 276666",
    d: "M129.954,117.325a.481.481,0,0,1-.467-.376c-1.391-6.474-2.91-15.451-2.273-21.48a.485.485,0,0,1,.476-.42h.053a.486.486,0,0,1,.423.529c-.629,5.9.876,14.767,2.256,21.171a.487.487,0,0,1-.367.568c-.031,0-.07.008-.1.008",
    transform: "translate(221.097 135.993)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276667",
    "data-name": "Path 276667",
    d: "M129.772,109.221a.483.483,0,0,1-.462-.353c0-.014-.484-1.775-1.113-4.446a.467.467,0,0,1,.353-.568.454.454,0,0,1,.568.353c.632,2.648,1.107,4.39,1.116,4.415a.478.478,0,0,1-.339.581.619.619,0,0,1-.122.017",
    transform: "translate(223.093 151.653)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276668",
    "data-name": "Path 276668",
    d: "M146.632,100.885a.463.463,0,0,1-.248-.07c-7.395-4.56-17.763-5.266-17.869-5.275a.476.476,0,0,1,.033-.951h.028c.428.031,10.7.729,18.3,5.414a.464.464,0,0,1,.161.651.477.477,0,0,1-.4.231",
    transform: "translate(222.888 135.171)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276669",
    "data-name": "Path 276669",
    d: "M136.807,104.186a.473.473,0,0,1-.323-.122c-5.706-5.2-7.319-5.536-7.642-5.536h-.022a.43.43,0,0,1-.476.231.473.473,0,0,1-.4-.54.772.772,0,0,1,.506-.581c.423-.125,1.661-.662,8.677,5.72a.481.481,0,0,1,.033.676.489.489,0,0,1-.353.153m-7.926-5.828v0Z",
    transform: "translate(222.654 140.486)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276670",
    "data-name": "Path 276670",
    d: "M130.513,99.6a.479.479,0,0,1-.476-.453c-.008-.175-.3-4.376-5.859-6.657a.475.475,0,0,1,.367-.876c6.137,2.52,6.435,7.289,6.443,7.489a.485.485,0,0,1-.454.5Z",
    transform: "translate(215.438 129.809)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276671",
    "data-name": "Path 276671",
    d: "M130.226,98.16a.283.283,0,0,1-.083-.008l-5.085-.921a.477.477,0,0,1-.384-.554.464.464,0,0,1,.554-.384l5.083.921a.477.477,0,0,1-.083.946",
    transform: "translate(216.824 138.179)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276672",
    "data-name": "Path 276672",
    d: "M122.454,106.1a.478.478,0,0,1-.323-.122.484.484,0,0,1-.031-.676c3.38-3.708,12.733-6.073,13.131-6.173a.5.5,0,0,1,.576.345.477.477,0,0,1-.345.576c-.092.022-9.475,2.4-12.655,5.9a.48.48,0,0,1-.353.153",
    transform: "translate(212.033 143.238)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276673",
    "data-name": "Path 276673",
    d: "M141.3,162.76a.952.952,0,0,1-.946-.868c-1.672-17.969-17.66-30.385-17.821-30.507a.949.949,0,0,1-.178-1.33.932.932,0,0,1,1.33-.175c.554.415,11.058,8.56,16.088,21.508l-2.888-51.879a.964.964,0,0,1,.9-1.007h.053a.956.956,0,0,1,.951.9l3.464,62.353a.96.96,0,0,1-.882,1.007Z",
    transform: "translate(212.356 142.144)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276674",
    "data-name": "Path 276674",
    d: "M129.648,148.76a.956.956,0,0,1-.951-.951c0-1.177.131-28.866,11.448-38.333a13.383,13.383,0,0,1,11.32-2.874.953.953,0,1,1-.339,1.875,11.367,11.367,0,0,0-9.759,2.456c-10.636,8.891-10.766,36.6-10.766,36.875a.956.956,0,0,1-.951.951",
    transform: "translate(224.006 156.144)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276675",
    "data-name": "Path 276675",
    d: "M131.957,181.181a.959.959,0,0,1-.946-.821c-.359-2.621-8.608-64.411,9.776-85.491A19.162,19.162,0,0,1,155.77,87.92a.951.951,0,1,1,0,1.9,17.367,17.367,0,0,0-13.548,6.29c-17.813,20.434-9.414,83.354-9.32,83.985a.957.957,0,0,1-.815,1.074c-.047,0-.092.008-.131.008",
    transform: "translate(224.294 123.287)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276676",
    "data-name": "Path 276676",
    d: "M143.258,113.26c-2.957-3.327-9.242-3.327-12.936,5.174s-.37,7.025-.37,7.025,7.022-2.217,11.459-3.7,10.349-5.174,10.719-2.957-2.957,4.437-7.025,5.175-14.784,3.7-13.676,5.914,3.7,8.872,3.7,8.872a94.2,94.2,0,0,1,9.979-7.392c4.807-2.957,7.765-1.85,5.177,1.477s-9.982,7.025-8.5,11.459,10.349,9.982,10.349,9.982,1.107-9.242,3.7-12.2,2.587.37,1.847,5.544a60.131,60.131,0,0,0-.74,6.655l10.352,3.694a73.306,73.306,0,0,1,5.544-7.392l1.847-1.847s-8.132-7.025-8.5-11.459,5.545,0,7.392.737,4.807,5.915,4.807,5.915,1.847-8.5,2.217-11.459l.37-2.957s-7.765-2.957-10.719-2.957-4.437,2.22-4.437-.737,2.957-4.807,6.285-4.437a57.741,57.741,0,0,1,8.872,2.217s2.217-1.847,1.477-7.392-2.587-5.545-7.022-4.067-7.395,4.807-10.722,4.807-1.477-4.067.74-5.174,7.762-3.327,8.872-3.7-5.914-5.544-9.612-6.285-8.482,1.864-8.132,5.544c.74,7.762-10.349,9.242-13.306,5.915",
    transform: "translate(223.792 147.798)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276677",
    "data-name": "Path 276677",
    d: "M142.951,123.641a.479.479,0,0,1-.476-.453c-.047-1.143-.122-2.256-.239-3.316a.487.487,0,0,1,.431-.523.512.512,0,0,1,.523.431c.106,1.074.192,2.212.236,3.363a.48.48,0,0,1-.453.5Z",
    transform: "translate(248.13 179.291)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276678",
    "data-name": "Path 276678",
    d: "M147,133.666a.475.475,0,0,1-.467-.4,98.469,98.469,0,0,0-6.927-22.79.485.485,0,0,1,.245-.629.5.5,0,0,1,.632.245,99.552,99.552,0,0,1,6.986,23.021.477.477,0,0,1-.389.545.275.275,0,0,1-.078.008",
    transform: "translate(243.376 162.295)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276679",
    "data-name": "Path 276679",
    d: "M141.62,119.441a.474.474,0,0,1-.431-.275c-1.8-3.873-3.177-6.273-3.194-6.3a.526.526,0,0,1-.039-.384.52.52,0,0,1,.262-.292,10.5,10.5,0,0,0,4.576-4.215,12.586,12.586,0,0,1,3.856-4.615.455.455,0,0,1,.654.131.467.467,0,0,1-.131.654,12.015,12.015,0,0,0-3.533,4.262,11.013,11.013,0,0,1-4.568,4.421c.476.868,1.6,2.979,2.98,5.937a.469.469,0,0,1-.231.629.451.451,0,0,1-.2.047",
    transform: "translate(240.47 150.646)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276680",
    "data-name": "Path 276680",
    d: "M133.758,114.836a.475.475,0,0,1-.184-.912c5.742-2.4,12.755-5.085,13.7-4.485a.683.683,0,0,1,.27.49.5.5,0,0,1-.823.323h-.006c-1.168,0-7.289,2.265-12.772,4.546a.542.542,0,0,1-.184.039",
    transform: "translate(232.182 161.481)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276681",
    "data-name": "Path 276681",
    d: "M141.2,111.3a.475.475,0,0,1-.214-.9c.245-.122,6.073-3.01,11.3-3.01a.476.476,0,1,1,0,.951c-5,0-10.819,2.879-10.875,2.9a.468.468,0,0,1-.214.053",
    transform: "translate(245.442 157.993)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276682",
    "data-name": "Path 276682",
    d: "M136.02,128.126a.415.415,0,0,1-.161-.031.47.47,0,0,1-.284-.606,31.92,31.92,0,0,1,5.244-8.646,53.3,53.3,0,0,1,7.1-7.1.477.477,0,1,1,.584.754,50.852,50.852,0,0,0-6.949,6.958,31.652,31.652,0,0,0-5.091,8.354.478.478,0,0,1-.445.314",
    transform: "translate(236.21 165.567)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276683",
    "data-name": "Path 276683",
    d: "M153.693,115.03a.478.478,0,0,1-.323-.122c-3.831-3.48-11.312-1.4-11.373-1.366a.513.513,0,0,1-.59-.331.485.485,0,0,1,.328-.593c.331-.075,8.065-2.234,12.28,1.583a.476.476,0,0,1-.323.829",
    transform: "translate(246.626 166.094)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276684",
    "data-name": "Path 276684",
    d: "M177.127,114.1c-4.026-2.381-8.477-2.434-10.658-4.946s2.1-3.781,4.393-2.835,7.6,3.681,8.607,4.276.309-8.1-1.555-11.376-6.969-5.183-9.52-2.507c-5.375,5.647-13.763-1.758-13.189-6.17s-3.544-9.161-12.388-6.379-5.547,4.326-5.547,4.326,6.279,3.85,10.3,6.229,10.694,4.423,9.261,6.157-5.289.676-8.513-1.911-12.483-8.741-13.431-6.449-4.276,8.607-4.276,8.607a93.855,93.855,0,0,1,12.124,2.69c5.383,1.689,6.485,4.649,2.278,4.877s-11.848-2.932-14.227,1.091-.751,14.358-.751,14.358,7.7-5.219,11.634-5.205,1.416,2.2-2.977,5.033a59.506,59.506,0,0,0-5.508,3.8l3.995,10.238a73.774,73.774,0,0,1,9.217-.659l2.607.184s-.028-10.744,3.08-13.932,3.636,4.187,4.29,6.068-1.316,7.506-1.316,7.506,7.631-4.176,10.107-5.837l2.473-1.658s-2.854-7.8-4.793-10.035-4.582-1.895-2.351-3.834,5.57-.918,7.47,1.836a57.587,57.587,0,0,1,4.142,8.154s2.849.462,6.552-3.731,2.49-5.589-1.533-7.968m-34.984,11.832c-2.957-1.48,4.067-4.437,4.067-4.437,2.587-.37-1.11,5.914-4.067,4.437m4.98-13.8c-1.26-.632,2.521-1.892,2.521-1.892,5.464,1.052-1.26,2.523-2.521,1.892",
    transform: "translate(225.427 115.12)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276685",
    "data-name": "Path 276685",
    d: "M133.464,104.5a.476.476,0,0,1-.345-.153.466.466,0,0,1,.022-.668c.776-.737,1.566-1.53,2.351-2.351a.516.516,0,0,1,.676-.017.489.489,0,0,1,.014.676c-.8.829-1.6,1.636-2.4,2.381a.471.471,0,0,1-.323.131",
    transform: "translate(231.655 146.933)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276686",
    "data-name": "Path 276686",
    d: "M135.191,114.139a.477.477,0,0,1-.362-.785,97.888,97.888,0,0,0,12.664-20.172.5.5,0,0,1,.637-.223.477.477,0,0,1,.223.637,99.268,99.268,0,0,1-12.8,20.372.472.472,0,0,1-.362.17",
    transform: "translate(234.736 132.191)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276687",
    "data-name": "Path 276687",
    d: "M140.262,97.019a.59.59,0,0,1-.192-.039.485.485,0,0,1-.245-.629c1.742-3.9,2.657-6.521,2.671-6.543a.456.456,0,0,1,.262-.284.533.533,0,0,1,.384.008,10.532,10.532,0,0,0,6.182.69,12.693,12.693,0,0,1,6.012-.114.478.478,0,0,1,.339.584.489.489,0,0,1-.584.337,11.733,11.733,0,0,0-5.536.114,11.15,11.15,0,0,1-6.335-.551c-.348.929-1.2,3.171-2.52,6.143a.487.487,0,0,1-.437.284",
    transform: "translate(243.769 126.09)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276688",
    "data-name": "Path 276688",
    d: "M146.844,97.04a.489.489,0,0,1-.362-.161.548.548,0,0,1-.114-.37c-.751-.874-6.488-4.014-11.818-6.663a.474.474,0,0,1-.209-.64.453.453,0,0,1,.64-.206c5.567,2.757,12.232,6.29,12.369,7.4a.714.714,0,0,1-.192.52.49.49,0,0,1-.314.117m-.314-.837v0Z",
    transform: "translate(233.971 125.1)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276689",
    "data-name": "Path 276689",
    d: "M151.055,100.29a.476.476,0,0,1-.362-.161c-3.277-3.786-9.267-6.29-9.328-6.312a.475.475,0,1,1,.367-.876c.253.1,6.251,2.612,9.684,6.56a.493.493,0,0,1-.047.676.5.5,0,0,1-.314.114",
    transform: "translate(246.063 132.171)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276690",
    "data-name": "Path 276690",
    d: "M131.53,96.765a.476.476,0,0,1-.17-.921,32.137,32.137,0,0,1,9.976-1.7c.376-.008.751-.008,1.113-.008a51.614,51.614,0,0,1,8.9.715.476.476,0,1,1-.184.935,54.21,54.21,0,0,0-9.815-.69,31.494,31.494,0,0,0-9.651,1.636.466.466,0,0,1-.17.031",
    transform: "translate(228.207 134.369)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276691",
    "data-name": "Path 276691",
    d: "M145.818,106.7h-.008a.474.474,0,0,1-.467-.484c.114-5.161-6.36-9.453-6.426-9.492a.476.476,0,0,1,.52-.8c.284.186,6.98,4.615,6.858,10.307a.477.477,0,0,1-.476.467",
    transform: "translate(241.83 137.407)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276692",
    "data-name": "Path 276692",
    d: "M150.522,128.664c-3.238-1.914-6.821-1.956-8.577-3.978s1.691-3.043,3.536-2.281,6.118,2.963,6.927,3.441.248-6.518-1.252-9.156-5.608-4.17-7.659-2.017c-4.329,4.546-11.078-1.413-10.616-4.966s-2.854-7.372-9.971-5.133-4.462,3.48-4.462,3.48,5.052,3.1,8.29,5.013,8.607,3.561,7.453,4.955-4.254.542-6.849-1.538-10.046-7.033-10.811-5.191-3.439,6.927-3.439,6.927a76.15,76.15,0,0,1,9.756,2.164c4.332,1.36,5.219,3.745,1.831,3.925s-9.531-2.359-11.448.879-.6,11.556-.6,11.556,6.2-4.2,9.361-4.19,1.141,1.767-2.393,4.048a48.693,48.693,0,0,0-4.434,3.06l3.213,8.24a59.39,59.39,0,0,1,7.42-.531l2.1.15s-.022-8.649,2.479-11.214,2.924,3.372,3.45,4.885-1.057,6.04-1.057,6.04,6.14-3.363,8.132-4.7l1.992-1.335s-2.3-6.276-3.859-8.073-3.686-1.527-1.889-3.085,4.479-.74,6.009,1.477a46.5,46.5,0,0,1,3.333,6.563s2.3.373,5.275-3,2-4.5-1.235-6.415m-28.151,9.523c-2.381-1.191,3.272-3.569,3.272-3.569,2.081-.3-.893,4.76-3.272,3.569m4.006-11.106c-1.015-.506,2.028-1.522,2.028-1.522,4.4.846-1.013,2.028-2.028,1.522",
    transform: "translate(194.592 151.776)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276693",
    "data-name": "Path 276693",
    d: "M115.445,121.092a.476.476,0,0,1-.345-.153.466.466,0,0,1,.022-.668c.707-.668,1.321-1.283,1.881-1.883a.473.473,0,0,1,.693.645c-.568.615-1.2,1.244-1.928,1.928a.487.487,0,0,1-.323.131",
    transform: "translate(199.545 177.309)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276694",
    "data-name": "Path 276694",
    d: "M116.835,128.843a.477.477,0,0,1-.362-.785,79.223,79.223,0,0,0,10.177-16.208.485.485,0,0,1,.637-.223.478.478,0,0,1,.223.637A80.164,80.164,0,0,1,117.2,128.673a.472.472,0,0,1-.362.17",
    transform: "translate(202.025 165.457)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276695",
    "data-name": "Path 276695",
    d: "M120.916,115.064a.59.59,0,0,1-.192-.039.485.485,0,0,1-.245-.629c1.4-3.133,2.142-5.238,2.15-5.252a.445.445,0,0,1,.259-.284.551.551,0,0,1,.384.006,8.2,8.2,0,0,0,4.907.545,10.269,10.269,0,0,1,4.891-.092.477.477,0,0,1,.339.584.5.5,0,0,1-.584.339,9.19,9.19,0,0,0-4.407.092,8.749,8.749,0,0,1-5.069-.409c-.3.793-.976,2.551-2,4.855a.486.486,0,0,1-.437.284",
    transform: "translate(209.295 160.546)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276696",
    "data-name": "Path 276696",
    d: "M126.206,115.085a.458.458,0,0,1-.362-.17.47.47,0,0,1-.114-.314c-.693-.729-5.244-3.224-9.453-5.314a.471.471,0,0,1-.209-.637.458.458,0,0,1,.64-.209c9.859,4.894,9.965,5.745,10,6.02a.65.65,0,0,1-.192.509.464.464,0,0,1-.306.114",
    transform: "translate(201.409 159.749)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276697",
    "data-name": "Path 276697",
    d: "M129.6,117.706a.476.476,0,0,1-.362-.161c-2.618-3.032-7.417-5.038-7.47-5.06a.475.475,0,1,1,.367-.876c.2.086,5.052,2.112,7.826,5.308a.493.493,0,0,1-.047.676.5.5,0,0,1-.314.114",
    transform: "translate(211.14 165.438)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276698",
    "data-name": "Path 276698",
    d: "M113.889,114.864a.476.476,0,0,1-.17-.921,25.825,25.825,0,0,1,8.057-1.369,40.9,40.9,0,0,1,8.079.57.484.484,0,0,1,.376.559.492.492,0,0,1-.562.376,40.834,40.834,0,0,0-6.994-.559c-.284,0-.584,0-.885.008a25.32,25.32,0,0,0-7.731,1.3.467.467,0,0,1-.17.031",
    transform: "translate(196.771 167.203)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276699",
    "data-name": "Path 276699",
    d: "M125.387,122.86h-.008a.474.474,0,0,1-.467-.484c.092-4.109-5.077-7.534-5.13-7.564a.477.477,0,1,1,.523-.8c.231.153,5.667,3.747,5.558,8.379a.477.477,0,0,1-.476.467",
    transform: "translate(207.734 169.651)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276700",
    "data-name": "Path 276700",
    d: "M141.6,98.393s-4.067,2.957-6.655,0,1.11-8.872-2.587-11.089-9.609,1.847-9.609,1.847,4.8,1.11,4.8,3.7-2.217,3.7-2.587,2.587-2.957-6.654-6.654-4.067a9.513,9.513,0,0,0-4.064,6.285s8.869-1.477,9.609,1.85-3.694-.37-7.392-.37-7.025.737-6.655,2.957a29.1,29.1,0,0,1,0,5.914,10.986,10.986,0,0,1,7.025-2.957c4.064,0,4.064,2.587.37,2.587s-6.655,3.694-6.655,3.694,3.7,5.547,8.132,8.135,5.915,1.477,6.285-.74-1.11-7.762,1.477-7.762-3.694,9.979-.37,10.349,5.914-.74,6.654-2.957l.74-2.217s-1.48-5.545-1.11-7.762,1.11,0,1.85,2.587,1.477,8.869,2.587,8.5,4.434-5.177,5.174-7.025-5.174-7.022-5.174-8.132,4.434.74,5.174,1.847a28.491,28.491,0,0,1,1.477,2.587s2.587-1.847,2.22-7.022-4.067-3.327-4.067-3.327",
    transform: "translate(190.305 121.01)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276701",
    "data-name": "Path 276701",
    d: "M114.081,103.395a.455.455,0,0,1-.275-.092.47.47,0,0,1-.109-.662c2.61-3.647,6.412-8.5,9.72-10.925a.478.478,0,1,1,.57.768c-3.21,2.348-6.949,7.125-9.523,10.711a.471.471,0,0,1-.384.2",
    transform: "translate(197.115 129.887)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276702",
    "data-name": "Path 276702",
    d: "M113.023,99.668a.437.437,0,0,1-.253-.078.464.464,0,0,1-.147-.651s.654-1.038,1.722-2.582a.468.468,0,0,1,.659-.122.479.479,0,0,1,.122.662c-1.052,1.527-1.7,2.548-1.7,2.548a.47.47,0,0,1-.4.223",
    transform: "translate(195.227 137.955)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276703",
    "data-name": "Path 276703",
    d: "M123.749,104.3a.481.481,0,0,1-.467-.392c-1.077-5.72-5.408-11.186-5.444-11.242a.475.475,0,0,1,.067-.668.493.493,0,0,1,.67.07c.184.231,4.521,5.706,5.642,11.673a.473.473,0,0,1-.384.551.258.258,0,0,1-.083.008",
    transform: "translate(204.464 130.369)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276704",
    "data-name": "Path 276704",
    d: "M117.717,100.831a.48.48,0,0,1-.479-.476c0-4.8-.467-5.928-.629-6.173a.478.478,0,0,1-.262-.876.692.692,0,0,1,.676-.008c.323.17,1.168.623,1.168,7.058a.479.479,0,0,1-.476.476",
    transform: "translate(201.622 132.721)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276705",
    "data-name": "Path 276705",
    d: "M117.541,95.668a.477.477,0,0,1-.337-.815c.106-.106,1.972-2.095.629-5.781a.473.473,0,1,1,.89-.323c1.566,4.293-.746,6.68-.846,6.78a.476.476,0,0,1-.337.139",
    transform: "translate(203.278 124.207)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276706",
    "data-name": "Path 276706",
    d: "M117.663,94.872a.46.46,0,0,1-.4-.223l-1.85-2.957a.464.464,0,0,1,.147-.651.452.452,0,0,1,.651.145l1.853,2.957a.464.464,0,0,1-.147.651.436.436,0,0,1-.253.078",
    transform: "translate(200.199 128.704)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276707",
    "data-name": "Path 276707",
    d: "M120.961,96.538a.444.444,0,0,1-.262-.078c-.053-.036-5.467-3.617-8.607-3.617a.476.476,0,1,1,0-.951c3.433,0,8.9,3.617,9.131,3.77a.486.486,0,0,1,.139.662.493.493,0,0,1-.4.214",
    transform: "translate(193.568 130.365)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25552",
    "data-name": "Rectangle 25552",
    width: 28.577,
    height: 41.132,
    transform: "translate(340.663 302.22)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276708",
    "data-name": "Path 276708",
    d: "M153.551,163.332H124.98a.959.959,0,0,1-.954-.951V121.243a.957.957,0,0,1,.954-.951h28.571a.957.957,0,0,1,.954.951v41.137a.959.959,0,0,1-.954.951m-27.62-1.906H152.6V122.195H125.932Z",
    transform: "translate(215.683 180.974)",
    fill: "#515255"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2TaDashboard);
export default __webpack_public_path__ + "static/media/2_TA__Dashboard.5c059161a33f6fd2f03c821f5490eeb9.svg";
export { ForwardRef as ReactComponent };